(function Module() {
	'use strict';
	
	mySynch.factory('AuditService', [
		'$rootScope',
		'ApiFactory',
		'ApiBase',
		'IndexedDBFactory',
		'MySynchFactory',
		'CookieFactory',
		'F360Constant',
		'ViewAuthorizationFactory',
		'mySynchEnumerationService',
		'$q',
		'$location',
		'clientLoggerService',
		function auditService($rootScope,api, apiBase, indexedDB, MSF,cookies, constant,viewAuth,mySynchEnumSvc,$q,$location, log) {
			var callbackOrLog	= apiBase.callbackOrLog;
            // fields an auditListItem should have
			var auditListItemFields = ["HerdId","AuditId","PersonId","Name","NextEvaluationDate","DetailsJson","SyncedOn","SyncedDevice","PublishedOn","ModifiedOn","CreatedOn","Lact1_VWP","Lact2_VWP","Deleted","ApiVersion","CheckedOutTo","Authors"];

			var activeHerd = _.get(MSF.getActiveHerd(),'herdId',_.get(MSF.getActiveFarm(),'herds[0].herdId'));

		   var initiallyLoadF360DataByFarmId =  function initiallyLoadF360DataByFarmId(farmId, performanceContext){
			if (window.navigator.onLine) {
				// if we haven't created then we need to create them
				log.info("Object Stores need to be created");
			   var listData = [];
			   var listDataCanAuditEdit = [];
			   var listquestionData = [];
			   var listAnswerData = [];
			   var listherds = [];
			   var listReviewAndResults = [];
			   var listPrePopulatedData = [];
			   var listPenListData = [];
				   api.getHerdsByFarmId(farmId, function gotHerds(err, herds) {
					   if (err) {
						   log.error('Failed to get herds by farmId.' + err);
					   }

					   if (herds) {
						   listherds.push(herds[0]);

						   var getListHerdsObjectStoreNameApi = {'data': listherds, 'tableName' : constant.getListherds, 'keyId' : 'herdId'};
						   indexedDB.createObjectStore(constant.getListherds, getListHerdsObjectStoreNameApi);
						   indexedDB.writeData(constant.getListherds, getListHerdsObjectStoreNameApi);

						   api.getListByHerdId(herds[0].herdId, performanceContext, function getF360ListByHerdId(err, data) {
							   if (err) {
								   log.error('error getting F360 list by herdId: ' + err);
							   }

								   
							   if (data && data.length) {
								   
								   _.forEach(data,function(auditListItem){
									  // On a new device , if there is an audit in progress for the current farm we want to make sure the check synced status flags to update the device.
									  if((_.isEqual(_.get(auditListItem,'HerdId'),herds[0].herdId) && (_.isNull(_.get(auditListItem,'PublishedOn',null)) || _.isEqual(_.get(auditListItem,'PublishedOn',null),"")) && (_.isEqual(_.get(auditListItem,'Deleted'),false)))){
									  _.set(auditListItem,'SyncedOn',moment(new Date(null)).toDate());
								   
									  }
									   _.set(auditListItem,'IsDeviceDirty',false);
										  
									

								   });
							   }else{
								   data = [];
							   }
							   
							   
							   var stringAuditList = JSON.stringify(data);
							   var auditList = {'herdId': herds[0].herdId, 'auditList': stringAuditList};
							   listData.push(auditList);

							   console.log("creating object store for getList with data");
							   var getListObjectStoreNameApi = {'data': listData, 'tableName' : constant.getList, 'keyId' : 'herdId'};
							   indexedDB.createObjectStore(constant.getList, getListObjectStoreNameApi);
							   indexedDB.writeData(constant.getList, getListObjectStoreNameApi);
									   
							   if (data && data.length > 0) {

							   /*
								  TODO: refactor the way indexeddb.service.js handles creating stores when they don't exist yet instead of just here. So that each screen can call an api call
										like getQuestionList 1: without having to go to the top level f360 report first to have the objectstores created 2: so that screens like the Published report will be
										able to call those api calls for a published audit that the user didn't create ,but has permissions to view it.
									   
									   Once that is done the 4 created.... flags and the forEach loop need to be removed and restored to either just creating the store for the top level f360 report and the other 
									   screens will create/populate the other stores when first requestsed or go back to just creating the all the stores below for the audit the user can edit.
							   */
								   var createdOverViewListStore = false;
								   var createdQuestionListStore = false;
								   var createdAnswerListStore = false;
								   var createdReviewResultsAndDraftStore = false;
								   var createdPrePopulatedDataStore = false;
								   var createdPenListDataStore = false;
							   _.forEach(data,function(audit){

								   
							 
									   api.getOverViewList(audit.AuditId, performanceContext, function getF360OverViewList(err, data) {
										   if (err) {
											   log.error('error getting edit audit data offline mode: ' + err);
										   }
										   
										   if (data && data.length) {
											   var overViewList = Object.values(data[0]);
											   var overViewListData = {'auditId': audit.AuditId, 'overviewList': overViewList[0]};
										   }else{
											   var overViewListData = {'auditId': audit.AuditId, 'overviewList': "[]"};
										   }
										   
											   listDataCanAuditEdit.push(overViewListData);

												 var getOverviewListObjectStoreNameApi = {'data': listDataCanAuditEdit, 'tableName' : constant.getOverViewList, 'keyId' : 'auditId'};
											   if(!createdOverViewListStore){
												   console.log("creating object store for getOverviewList with data");
												   indexedDB.createObjectStore(constant.getOverViewList, getOverviewListObjectStoreNameApi);
												   indexedDB.writeData(constant.getOverViewList, getOverviewListObjectStoreNameApi);
												   createdOverViewListStore = true; 
											   }else{
												   console.log("writing data to existing object store for getOverviewList with data");
												   indexedDB.writeData(constant.getOverViewList, getOverviewListObjectStoreNameApi);
											   }	
										   
												   
										   
									   });

									   api.getQuestionList(audit.AuditId, performanceContext, function getF360QuestionList(err, data) {
										   if (err) {
											   log.error('error getting edit audit data offline mode: ' + err);
										   }
										   if (data && data.length > 0) {
											   var questionListData = {'auditId': data[0].AuditId, 'questionList': data[0].QuestionsJson};
										   

											   var answerListData = {'auditId': data[0].AuditId, 'answerList': data[0].AnswersJson};
										   
										   }else{
											   var questionListData = {'auditId': data[0].AuditId, 'questionList': '{"QuestionsJson": []}'};
										   

											   var answerListData = {'auditId': data[0].AuditId, 'answerList': "[]"};
											   
										   }
										   listquestionData.push(questionListData);
										   listAnswerData.push(answerListData);

											   var getQuestionListObjectStoreNameApi = {'data': listquestionData, 'tableName' : constant.getQuestionList, 'keyId' : 'auditId'};
											   if(!createdQuestionListStore){
												   console.log("creating object store for getQuestionList with data");
												   indexedDB.createObjectStore(constant.getQuestionList, getQuestionListObjectStoreNameApi);
												   indexedDB.writeData(constant.getQuestionList, getQuestionListObjectStoreNameApi);
												   createdQuestionListStore = true;
											   }else{
												   console.log("writing data to existing object store for getQuestionList with data");
												   indexedDB.writeData(constant.getQuestionList, getQuestionListObjectStoreNameApi);
											   }

											   var getAnswerListObjectStoreNameApi = {'data': listAnswerData, 'tableName' : constant.getAnswerList, 'keyId' : 'auditId'};
											   if(!createdAnswerListStore){
												   console.log("creating object store for getAnswerList with data");
												   indexedDB.createObjectStore(constant.getAnswerList, getAnswerListObjectStoreNameApi);
												   indexedDB.writeData(constant.getAnswerList, getAnswerListObjectStoreNameApi);
												   createdAnswerListStore = true;
											   }else{
												   console.log("writing data to existing object store for getAnswerList with data");
												   indexedDB.writeData(constant.getAnswerList, getAnswerListObjectStoreNameApi);
											   }

										   
									   });
									   api.getReviewResultsAndDraft(audit.AuditId, performanceContext, function getF360ReviewResultsAndDraft(err, data) {
										   if (err) {
											   log.error('error getting edit audit data offline mode: ' + err);
										   }
										   
										   if (data && data.length) {
											   var reviewResultsAndDraft = data[0];
											   var reviewResultsAndDraftData = {'auditId': audit.AuditId, 'reviewResultsAndDraft': _.get(reviewResultsAndDraft,'DraftNotesJson')};
										   }else{
											   var reviewResultsAndDraftData = {'auditId': audit.AuditId, 'reviewResultsAndDraft': null};
										   }
										   
											   
											   listReviewAndResults.push(reviewResultsAndDraftData);

											   var getReviewResultsAndDraftObjectStoreNameApi = {'data': listReviewAndResults, 'tableName' : constant.getReviewResultsAndDraft, 'keyId' : 'auditId'};
											   if(!createdReviewResultsAndDraftStore){
												   console.log("creating object store for getReviewResultsAndDraft with data");
												   indexedDB.createObjectStore(constant.getReviewResultsAndDraft, getReviewResultsAndDraftObjectStoreNameApi);
												   indexedDB.writeData(constant.getReviewResultsAndDraft, getReviewResultsAndDraftObjectStoreNameApi);
												   createdReviewResultsAndDraftStore = true;
											   }else{
												   console.log("writing data to existing object store for getReviewResultsAndDraft with data");
												   indexedDB.writeData(constant.getReviewResultsAndDraft, getReviewResultsAndDraftObjectStoreNameApi);
											   }
										   
									   });

									   api.getPrePopulatedData(audit.AuditId, performanceContext, function getF360PrePopulatedData(err, data) {
										   if (err) {
											   log.error('error getting PrePopulated Data offline mode: ' + err);
										   }
										   
										   if (data && data.length) {
											   var prePopulatedDataList = Object.values(data[0]);
											   var prePopulatedDataListData = {'auditId': audit.AuditId, 'prePopulatedData': prePopulatedDataList[1]};
										   }else{
											   var prePopulatedDataListData = {'auditId': audit.AuditId, 'prePopulatedData': "[]"};
										   }
											   listPrePopulatedData.push(prePopulatedDataListData);

												var  getPrePopulatedDateObjectStoreNameApi = {'data': listPrePopulatedData, 'tableName' : constant.getPrePopulatedData, 'keyId' : 'auditId'};
											   if(!createdPrePopulatedDataStore){
												   console.log("creating object store for getPrePopulatedData with data");
												   indexedDB.createObjectStore(constant.getPrePopulatedData, getPrePopulatedDateObjectStoreNameApi);
												   indexedDB.writeData(constant.getPrePopulatedData, getPrePopulatedDateObjectStoreNameApi);
												   createdPrePopulatedDataStore = true; 
											   }else{
												   console.log("writing data to existing object store for getPrePopulatedData with data");
												   indexedDB.writeData(constant.getPrePopulatedData, getPrePopulatedDateObjectStoreNameApi);
											   }	
												   
										   
									   });
									   api.getPenListData(audit.AuditId, performanceContext, function getF360PenListData(err, data) {
										if (err) {
											log.error('error getting Pen List Data offline mode: ' + err);
										}
										var prePopulatedPenList = [];
										if (data && data.length) {
											var penListData = Object.values(data[0]);
											try{
												prePopulatedPenList = JSON.parse(penListData[1]);
												if(_.isNull(prePopulatedPenList)){
													prePopulatedPenList = [];
												}
											}catch(e){
												log.error("failed to parse prepopulated data json data from server");
											}
										
											var penListDataListData = {'auditId': audit.AuditId, 'penListData': JSON.stringify(prePopulatedPenList)};
										}else{
											var penListDataListData = {'auditId': audit.AuditId, 'penListData': "[]"};
										}
											listPenListData.push(penListDataListData);

											 var  getPenListDateObjectStoreNameApi = {'data': listPenListData, 'tableName' : constant.getPenListData, 'keyId' : 'auditId'};
											if(!createdPenListDataStore){
												console.log("creating object store for getPenListData with data");
												indexedDB.createObjectStore(constant.getPenListData, getPenListDateObjectStoreNameApi);
												indexedDB.writeData(constant.getPenListData, getPenListDateObjectStoreNameApi);
												createdPenListDataStore = true; 
											}else{
												console.log("writing data to existing object store for getPenListData with data");
												indexedDB.writeData(constant.getPenListData, getPenListDateObjectStoreNameApi);
											}	
												
										
									});
									   
							 
									   });
									   $rootScope.$broadcast("auditService:objectStores-initialized");
							   }else{
								   // even if the farm doesn't have any audits yet , we stil want to create the object stores with default values that later calls to the stores doens't break the app
								  log.info("There were no audits continuing to create object stores with default values");
								  console.log("There were no audits creating object store for getList with default data");
								
								  var getOverviewListObjectStoreNameApi = {'data': [], 'tableName' : constant.getOverViewList, 'keyId' : 'auditId'};
								  indexedDB.createObjectStore(constant.getOverViewList, getOverviewListObjectStoreNameApi);

								  var getQuestionListObjectStoreNameApi = {'data': [], 'tableName' : constant.getQuestionList, 'keyId' : 'auditId'};
								  indexedDB.createObjectStore(constant.getQuestionList, getQuestionListObjectStoreNameApi);

								  var getAnswerListObjectStoreNameApi = {'data': [], 'tableName' : constant.getAnswerList, 'keyId' : 'auditId'};
								  indexedDB.createObjectStore(constant.getAnswerList, getAnswerListObjectStoreNameApi);

								  var getReviewResultsAndDraftObjectStoreNameApi = {'data': [], 'tableName' : constant.getReviewResultsAndDraft, 'keyId' : 'auditId'};
								  indexedDB.createObjectStore(constant.getReviewResultsAndDraft, getReviewResultsAndDraftObjectStoreNameApi);

								  var getPrePopulatedDateObjectStoreNameApi = {'data': [], 'tableName' : constant.getPrePopulatedData, 'keyId' : 'auditId'};
								  indexedDB.createObjectStore(constant.getPrePopulatedData, getPrePopulatedDateObjectStoreNameApi);

								  var getPenListDateObjectStoreNameApi = {'data': [], 'tableName' : constant.getPenListData, 'keyId' : 'auditId'};
								  indexedDB.createObjectStore(constant.getPenListData, getPenListDateObjectStoreNameApi);
								  
								 console.log("created empty object stores for audit data since there are no audits for this farm yet");
								  $rootScope.$broadcast("auditService:objectStores-initialized");

							   }
					   
						   });
					   }
				   });
			}
		   
	   };

	var needToLazyLoad  = function needToLazyLoad(herd,personId){
    
		var needToLazyLoadPromise = $q.defer();
		// we always lazyload again for farm admins that are not a vet
		if(!(viewAuth.hasRole(mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'))) && !(viewAuth.hasRole(mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER'))) && !(viewAuth.hasRole(mySynchEnumSvc.getMySynchEnumeration('Role','ADMIN')))){
			needToLazyLoadPromise.resolve(true);
	    }else{
        // first if herd is undefined then we assume no data for the farm is loaded yet and we need to lazyload
		if(_.isUndefined(herd)){
			needToLazyLoadPromise.resolve(true);
		}else{

			//if herd did exist we next need to check the number of audits between the server and the device
			// if the server has more audits, then the farm data needs to be lazyloaded again.
			indexedDB.readData(constant.getList, constant.getList, function getData(err, indexDBListData){
				if (err) {
					console.log('err', err);								
				}

				if (indexDBListData && indexDBListData.length) {

				
					var getListObjectStoreList = _.clone(indexDBListData);

					var auditListItem  = _.find(getListObjectStoreList,{herdId: herd.herdId});

					var deviceAuditList = [];
					// if this farm doesn't have any audits yet, it might have been loaded already , but there won't me to much to load to allow another lazy load.
					if(_.isUndefined(auditListItem)){				
				    	needToLazyLoadPromise.resolve(true);
					}else{
						deviceAuditList = JSON.parse(_.get(auditListItem,'auditList',"[]" ));
					

					
					api.getListByHerdId(herd.herdId, null, function getF360ListByHerdId(err, serverListData) {
						if (err) {
							log.error('error getting F360 list by herdId: ' + err);
						
						}
					
							
							var serverAuditList = _.clone(serverListData);
							

							// if there is a difference in the number of audits between the server and the device, then either audit(s) were either deleted or published since this device called up this farm. 
							// so we need to lazyload. 

							if(!_.isEqual(deviceAuditList.length,serverAuditList.length)){
								needToLazyLoadPromise.resolve(true);
							}else {
							
							if (serverListData && serverListData.length) {
								// if the number of audits are the same we need to check see if there is an active audit
						
								
								// for both server side and device side we don't want to flag a lazy load due to active audit because active audits are handled by  the check sync timer.
								var auditOutOfSync = _.some(deviceAuditList,function(deviceAudit){
                                      return  !_.isUndefined(_.find(serverAuditList,function(serverAudit){
									    if(_.isEqual(_.get(deviceAudit,'AuditId'),_.get(serverAudit,'AuditId')) && !(_.isNull(_.get(serverAudit,'PublishedOn',null)) || _.isEqual(_.get(serverAudit,'PublishedOn'),""))){
											var serverSyncedOnString  = _.get(serverAudit,'SyncedOn',null);
											var deviceSyncedOnString  = _.get(deviceAudit,'SyncedOn',null);

											if(_.isNull(deviceSyncedOnString)){
                                                return true; 
											}else{
												var serverSyncedOn = moment(serverSyncedOnString).subtract(moment(serverSyncedOnString).utcOffset(), 'minutes');
												var deviceSyncedOn = moment(deviceSyncedOnString).subtract(moment(deviceSyncedOnString).utcOffset(), 'minutes');
	  
											    return serverSyncedOn.isAfter(deviceSyncedOn);
											}

										  

									    }
		   
									  }));
									 
								});

								if(auditOutOfSync ===  true){
									needToLazyLoadPromise.resolve(true);
								}else{   
									
								    // confirm that the audits on the device all have the needed fields
									var deviceAuditListHasAllFields = _.every(deviceAuditList,function(deviceAudit){
										return _.every(auditListItemFields,function(field){
											return _.has(deviceAudit,field);//!_.isUndefined(_.get(deviceAudit,field));
										});
									});
									if(!deviceAuditListHasAllFields){
										needToLazyLoadPromise.resolve(true);
									}else{

								     	needToLazyLoadPromise.reject(false);
									}
								}
								


						}else{
							 //if the server has less audits than the device than server, we don't want to lazyload over the devices data, instead we want the device to update the server
							 // this path is put here just to not leave a code path with an unresolved promise. Its unlikely that the device would have audits that the server doens't know about since you have to be online (which syncs with the server) to create an audit 
							 needToLazyLoadPromise.reject(false);
						}
					}
					});
				 }

				}else{
					//if no farms have any audits yet, including the one passed into this function , we need to lazy load.
					needToLazyLoadPromise.resolve(true);
				}

		});
		
		}
	}
	   
		return needToLazyLoadPromise.promise;

	};

	var lazyLoadF360DataByFarmId = function lazyLoadF360DataByFarmId(farmId,personId, performanceContext){
		if (window.navigator.onLine) {
			indexedDB.readData(constant.getListherds, constant.getListherds, function getData(err, listHerdsData){
				if (err) {
					log.error('Failed to get herds by farmId.' + err);
				}
				

				var herd = _.find(listHerdsData,{farmId: farmId});
                
				needToLazyLoad(herd,personId).then(function proceedWithLazyLoad(value){ // if(proceedWithLazyLoad){

				   // getListHerds Data 
				   api.getHerdsByFarmId(farmId, function gotHerds(err, herds) {
						if (err) {
							log.error('Failed to get herds by farmId.' + err);
						}

						// right now we only have one herd per farm. So we just grab the first index of api results
						var serverHerd = herds[0];
						
						var herdIndex =  listHerdsData.findIndex(item => item.herdId == serverHerd.herdId);

						var dataUpdateListHerds = _.clone(listHerdsData);
						
						if(herdIndex > -1){
							dataUpdateListHerds.splice(herdIndex,1);
						}

						dataUpdateListHerds.push(serverHerd);
						

						var getListHerdsObjectStoreNameApi = {'data': dataUpdateListHerds, 'tableName' : constant.getListherds, 'keyId' : 'herdId'};
						indexedDB.createObjectStore(constant.getListherds, getListHerdsObjectStoreNameApi);
						indexedDB.writeData(constant.getListherds, getListHerdsObjectStoreNameApi);


						//getList Data

						indexedDB.readData(constant.getList, constant.getList, function getData(err, indexDBListData){
							if (err) {
								console.error('error in reading getList objectstore (lazyLoadF360DataByFarmId): ', err);						
							}
	
							if (indexDBListData && indexDBListData.length) {
	
	
								var getListIndex = indexDBListData.findIndex(item => item.herdId == serverHerd.herdId);
								var dataListUpdate = _.clone(indexDBListData);
	
	
								if (getListIndex > -1) {
									dataListUpdate.splice(getListIndex, 1);														
								}

                                
								api.getListByHerdId(serverHerd.herdId, performanceContext, function getF360ListByHerdId(err, serverListData) {
									if (err) {
										log.error('error getting F360 list by herdId: ' + err);
									
									}
									if (serverListData && serverListData.length) {

										 // we want to remove the unpublished audits from this list so that the sync timer on the F360 Dashboard works   properly
										 
										 serverListData = _.filter(serverListData,function(auditListItem){
                                                return !(_.isNull(_.get(auditListItem,'PublishedOn',null)) || _.isEqual(_.get(auditListItem,'PublishedOn'),""));
										 });

										// when getList is first initialized all audit list items need IsDeviceDirty = false
										_.forEach(serverListData,function(auditListItem){
										_.set(auditListItem,'IsDeviceDirty',_.get(auditListItem,'IsDeviceDirty',false));
				
										});

		
										var stringAuditList = JSON.stringify(serverListData);
										var auditList = {'herdId': serverHerd.herdId, 'auditList': stringAuditList};
										dataListUpdate.push(auditList);
				
										var objectStoreNameApi = {'data': dataListUpdate, 'tableName' : constant.getList, 'keyId' : 'herdId'};
										indexedDB.createObjectStore(constant.getList, objectStoreNameApi);
										indexedDB.writeData(constant.getList, objectStoreNameApi);

										 var overviewListObjStoreData = [];
										 var questionListObjStoreData = [];
										 var answerListObjStoreData = [];
										 var reviewAndResultsListObjStoreData = [];
										 var prePopulatedDataListObjStoreData = [];
										 var penListDataListObjStoreData = [];
										 
										_.forEach(serverListData,function(audit){

											// we only want to lazy load published audits , active audits will be handled with the check sync timer for the person who is doing the audit.
											if(!(_.isNull(_.get(audit,'PublishedOn',null)) || _.isEqual(_.get(audit,'PublishedOn'),""))){
												//  getOverviewList Data
										
												api.getOverViewList(audit.AuditId, performanceContext, function getF360OverViewList(err, serverOverviewListData) {
													if (err) {
														log.error('error getting overView list: ' + err);
													}
						
												
													if (serverOverviewListData && serverOverviewListData.length) {

														var overViewList = Object.values(serverOverviewListData[0]);

												
							
															var overViewListData = {'auditId': audit.AuditId, 'overviewList': overViewList[0]};
															overviewListObjStoreData.push(overViewListData);
					
                                                             
																 // getQuestionList Data
																
																	   
																api.getQuestionList(audit.AuditId, performanceContext, function getF360QuestionList(err, serverQuestionListData) {
																	if (err) {
																		log.error('error getting edit audit data offline mode: ' + err);
																	}
																	if (serverQuestionListData && serverQuestionListData.length) {
																		var questionsListJson = serverQuestionListData[0].QuestionsJson;

																																		
										
																			var questionListData = {'auditId': audit.AuditId, 'questionList': questionsListJson};
																			questionListObjStoreData.push(questionListData);
									

																				// getAnswerList Data


																					 if (!_.isUndefined(serverQuestionListData[0].AnswersJson) && !_.isNull(serverQuestionListData[0].AnswersJson)) {
																														 
																						var answerListData = {'auditId': audit.AuditId, 'answerList': serverQuestionListData[0].AnswersJson};
																					
																					}else{																				
										 
																						var answerListData = {'auditId': audit.AuditId, 'answerList': "[]"};
																						
																					}
																					  
																					answerListObjStoreData.push(answerListData);

																					// get Results and Write , Review Draft Data
																					api.getReviewResultsAndDraft(audit.AuditId, performanceContext, function getF360ReviewResultsAndDraft(err, reviewResultsAndDraftData) {
																						if (err) {
																							log.error('error getting PrePopulated Data During device update: ' + err);
																						}
																						
																						if (reviewResultsAndDraftData && reviewResultsAndDraftData.length) {
																								
																							var reviewResultsAndDraft = reviewResultsAndDraftData[0];
																							var reviewResultsAndDraftData = {'auditId': audit.AuditId, 'reviewResultsAndDraft': _.get(reviewResultsAndDraft,'DraftNotesJson')};
																						}else{
																							var reviewResultsAndDraftData = {'auditId': audit.AuditId, 'reviewResultsAndDraft': null};
																						}

																					
																							
																							reviewAndResultsListObjStoreData.push(reviewResultsAndDraftData);


																								// getPrePopulatedData Data
																								api.getPrePopulatedData(audit.AuditId, performanceContext, function getF360PrePopulatedData(err, data) {
																									if (err) {
																										log.error('error getting PrePopulated Data offline mode: ' + err);
																									}
																									
																									if (data && data.length) {
																										var prePopulatedDataList = Object.values(data[0]);
																										var prePopulatedDataListData = {'auditId': audit.AuditId, 'prePopulatedData': prePopulatedDataList[1]};
																									}else{
																										var prePopulatedDataListData = {'auditId': audit.AuditId, 'prePopulatedData': "[]"};
																									}

																										prePopulatedDataListObjStoreData.push(prePopulatedDataListData);

																								api.getPenListData(audit.AuditId, performanceContext, function getPenListData(err, data){

																									if (err) {
																										log.error('error getting Pen List Data offline mode: ' + err);
																									}
																									var prePopulatedPenList = [];
																									if (data && data.length) {
																										var penListData = Object.values(data[0]);
																										try{
																											prePopulatedPenList = JSON.parse(penListData[1]);
																											if(_.isNull(prePopulatedPenList)){
																												prePopulatedPenList = [];
																											}
																										}catch(e){
																											log.error("failed to parse prepopulated data json data from server");
																										}
																										var penListDataListData = {'auditId': audit.AuditId, 'penListData': JSON.stringify(prePopulatedPenList)};
																									}else{
																										var penListDataListData = {'auditId': audit.AuditId, 'penListData': "[]"};
																									}
															
																								
																									penListDataListObjStoreData.push(penListDataListData);

																													// overview list
																						
																											indexedDB.readData(constant.getOverViewList, constant.getOverViewList, function getData(err, overviewListData){
																												if (err) {
																													console.error('error in reading getOverViewList objectstore (lazyLoadF360DataByFarmId): ', err);
																												}

																												var overviewListUpdate = [];
																												if(_.isArray(overviewListObjStoreData)){
																													overviewListUpdate = _.clone(overviewListObjStoreData);
																												}


																												if (overviewListData && overviewListData.length) {
																												var currentOverviewListIndexeDBData = _.clone(overviewListData);
																												var otherFarmOverviewListData = _.reject(currentOverviewListIndexeDBData,function(listItem){ return !_.isUndefined(_.find(overviewListObjStoreData,{auditId: listItem.auditId})); }); 
																												overviewListUpdate  =  overviewListUpdate.concat(otherFarmOverviewListData);


																												}	
																						
																										

																												var objectStoreNameApi = {'data': overviewListUpdate, 'tableName' : constant.getOverViewList, 'keyId' : 'auditId'};
																												indexedDB.createObjectStore(constant.getOverViewList, objectStoreNameApi);
																												indexedDB.writeData(constant.getOverViewList, objectStoreNameApi);
																											});

																											// question list
																												indexedDB.readData(constant.getQuestionList, constant.getQuestionList, function getData(err, indexDbQuestionListData){
																													if (err) {
																														console.error('error in reading getQuestionList objectstore (lazyLoadF360DataByFarmId): ', err);
																													}
																													
																													var questionListUpdate = [];
																													if(_.isArray(questionListObjStoreData)){
																														questionListUpdate = _.clone(questionListObjStoreData);
																													}

																											
																													if (indexDbQuestionListData && indexDbQuestionListData.length) {

																														
																														var currentQuestionListIndexeDBData = _.clone(indexDbQuestionListData);

																														var otherFarmQuestionListData = _.reject(currentQuestionListIndexeDBData,function(listItem){ return !_.isUndefined(_.find(questionListObjStoreData,{auditId: listItem.auditId})); }); 
																														questionListUpdate =  questionListUpdate.concat(otherFarmQuestionListData);

																										

																													}

																														

																													var objectStoreNameApi = {'data': questionListUpdate, 'tableName' : constant.getQuestionList, 'keyId' : 'auditId'};
																													indexedDB.createObjectStore(constant.getQuestionList, objectStoreNameApi);
																													indexedDB.writeData(constant.getQuestionList, objectStoreNameApi);

																												});
																	
																																			

																											// answer list


																												indexedDB.readData(constant.getAnswerList, constant.getAnswerList, function getData(err, getAnswerListData){
																													if (err) {
																														console.error('error in reading getAnswerList objectstore (lazyLoadF360DataByFarmId): ', err);
																													}
																												
																													var answerListUpdate = [];
																													if(_.isArray(answerListObjStoreData)){
																														answerListUpdate = _.clone(answerListObjStoreData);
																													}

																													if (_.isArray(getAnswerListData) && getAnswerListData.length > 0) {
																														var currentAnswerListIndexeDBData = _.clone(getAnswerListData);

																														var otherFarmAnswerListData = _.reject(currentAnswerListIndexeDBData,function(listItem){ return !_.isUndefined(_.find(answerListObjStoreData,{auditId: listItem.auditId})); }); 
																														answerListUpdate =   answerListUpdate.concat(otherFarmAnswerListData);

																									
																													}

																									

																													var getAnswerListObjectStoreNameApi = {'data': answerListUpdate, 'tableName' : constant.getAnswerList, 'keyId' : 'auditId'};
																													
																													indexedDB.createObjectStore(constant.getAnswerList, getAnswerListObjectStoreNameApi);
																													indexedDB.writeData(constant.getAnswerList, getAnswerListObjectStoreNameApi);
																												});
																											// review and draft list

																											indexedDB.readData(constant.getReviewResultsAndDraft, constant.getReviewResultsAndDraft, function getData(err, getReviewResultsAndDraftIndexDbData){
																													if (err) {
																														console.error('error in reading getReviewResultsAndDraft objectstore (lazyLoadF360DataByFarmId): ', err);
																													}
																												
																												
																													var reviewResultsAndDraftListUpdate = [];
																													if(_.isArray(reviewAndResultsListObjStoreData)){
																														reviewResultsAndDraftListUpdate = _.clone(reviewAndResultsListObjStoreData);
																													}


																													if (getReviewResultsAndDraftIndexDbData && getReviewResultsAndDraftIndexDbData.length) {

																														var currentReviewResultsAndDraftListIndexeDBData = _.clone(getReviewResultsAndDraftIndexDbData);

																														var otherFarmResultsAndDraftListData = _.reject(currentReviewResultsAndDraftListIndexeDBData,function(listItem){ return !_.isUndefined(_.find(reviewAndResultsListObjStoreData,{auditId: listItem.auditId})); }); 
																														reviewResultsAndDraftListUpdate = reviewResultsAndDraftListUpdate.concat(otherFarmResultsAndDraftListData);
																														
																												
																													}
																													
																										

																													var getReviewResultsAndDraftObjectStoreNameApi = {'data': reviewResultsAndDraftListUpdate, 'tableName' : constant.getReviewResultsAndDraft, 'keyId' : 'auditId'};
																											
																													indexedDB.createObjectStore(constant.getReviewResultsAndDraft, getReviewResultsAndDraftObjectStoreNameApi);
																													indexedDB.writeData(constant.getReviewResultsAndDraft, getReviewResultsAndDraftObjectStoreNameApi);
																											});


																											// prepopulated data list

																												indexedDB.readData(constant.getPrePopulatedData, constant.getPrePopulatedData, function getData(err, getPrePopulatedDataIndexDbData) {
																													if (err) {
																														console.error('error in reading getPrePopulatedData objectstore (lazyLoadF360DataByFarmId): ', err);
																													}

																											
																													var prePopulatedDataListUpdate = [];
																													if(_.isArray(prePopulatedDataListObjStoreData)){
																														prePopulatedDataListUpdate = _.clone(prePopulatedDataListObjStoreData);
																													}
																												
																													if (!_.isNull(getPrePopulatedDataIndexDbData) && getPrePopulatedDataIndexDbData.length > 0) {

																														var currentPrePopulatedDataListIndexeDBData = _.clone(getPrePopulatedDataIndexDbData);

																														var otherFarmPrePopulatedDataListData = _.reject(currentPrePopulatedDataListIndexeDBData,function(listItem){ return !_.isUndefined(_.find(prePopulatedDataListObjStoreData,{auditId: listItem.auditId})); }); 
																														prePopulatedDataListUpdate =  prePopulatedDataListUpdate.concat(otherFarmPrePopulatedDataListData);

																												
																													}
																													
																												

																														var  getPrePopulatedDateObjectStoreNameApi = {'data': prePopulatedDataListUpdate, 'tableName' : constant.getPrePopulatedData, 'keyId' : 'auditId'};
																													
																														indexedDB.createObjectStore(constant.getPrePopulatedData, getPrePopulatedDateObjectStoreNameApi);
																														indexedDB.writeData(constant.getPrePopulatedData, getPrePopulatedDateObjectStoreNameApi);
																																														
																																															
																																													
																												});

																												// pen list data list

																												indexedDB.readData(constant.getPenListData, constant.getPenListData, function getData(err, getPenListDataIndexDbData) {
																													if (err) {
																														console.error('error in reading getPenListData objectstore (lazyLoadF360DataByFarmId): ', err);
																													}

																											
																													var penListDataListUpdate = [];
																													if(_.isArray(penListDataListObjStoreData)){
																														penListDataListUpdate = _.clone(penListDataListObjStoreData);
																													}
																												
																													if (!_.isNull(getPenListDataIndexDbData) && getPenListDataIndexDbData.length > 0) {

																														var currentPenListDataListIndexeDBData = _.clone(getPenListDataIndexDbData);

																														var otherFarmPenListDataListData = _.reject(currentPenListDataListIndexeDBData,function(listItem){ return !_.isUndefined(_.find(penListDataListObjStoreData,{auditId: listItem.auditId})); }); 
																														penListDataListUpdate =  penListDataListUpdate.concat(otherFarmPenListDataListData);

																												
																													}
																													
																												

																														var  getPenListDateObjectStoreNameApi = {'data': penListDataListUpdate, 'tableName' : constant.getPenListData, 'keyId' : 'auditId'};
																													
																														indexedDB.createObjectStore(constant.getPenListData, getPenListDateObjectStoreNameApi);
																														indexedDB.writeData(constant.getPenListData, getPenListDateObjectStoreNameApi);
																																														
																																															
																																													
																												});

																																									
																																								
																								                                                                 });
																																							
																																						});


																																			
																																					

																																				
																																			});

																																		
																																		
																																												
																																		
																																	
																																
																																
																															}	
																															
																														});
																														


																												
																						
																													
																											
																											}
																											
																										});
																									}
																								
																								
																								});


									

											
									}else{
									
										var auditList = [];
									
										var stringAuditList = JSON.stringify(auditList);
										var auditList = {'herdId': serverHerd.herdId, 'auditList': stringAuditList};
										dataListUpdate.push(auditList);
				
										var objectStoreNameApi = {'data': dataListUpdate, 'tableName' : constant.getList, 'keyId' : 'herdId'};
										indexedDB.createObjectStore(constant.getList, objectStoreNameApi);
										indexedDB.writeData(constant.getList, objectStoreNameApi);
									}

									
			
				
									});

							
							}
	
						});

				
				   });
				
				
				
				});


				
			});
	 }
					
	};
			
			var service =  {
				isCompleted: function isCompleted() {
					// TODO
					return false;
				},
				checkNotApplicable:function (questionDetails) {
					return questionDetails.Question.trim() === constant.questionNotApplicable;
				},
				checkQuestionNumberCowsInPen: function(questionDetails) {
					return questionDetails.Question.trim() === constant.questionNumberCowsInPen;
				},
				checkAverageQuesitonLS: function(questionDetails) {
					return questionDetails.Question.trim() === constant.questionAverageLS;
				},
				checkAverageQuesitonBCS: function(questionDetails) {
					return questionDetails.Question.trim() === constant.questionAverageBCS;
				},
				checkQuestionStockDensity: function(questionDetails){
					return questionDetails.Question.trim() === constant.questionStockDensity;
				},
				checkQuestionOverallDataQuality: function(questionDetails){
					return questionDetails.Question.trim() === constant.questionOverallDataQuality;
				},
				checkQuestionTurnoverRate: function(questionDetails){
					return questionDetails.Question.trim() === constant.questionTurnoverRate;
				},
				checkQuestionCowPersonnelRatio: function(questionDetails){
					return questionDetails.Question.trim() === constant.questionCowPersonnelRatio;
				},
				checkQuestionChngBSCDryCowsCloseFar: function(questionDetails){
					return questionDetails.Question.trim() === constant.questionChngBSCDryCowsCloseFar;
				},
				checkQuestionChngBSCDryCowsFreshClose: function(questionDetails){
					return questionDetails.Question.trim() === constant.questionChngBSCDryCowsFreshClose;
				},

				getAuditId: function getAuditId(link) {
					var linkArr = link.split("/");
					var auditId = Number(linkArr[2]);
					return auditId;
				},
				getCurrentAuditVersion: function getCurrentAuditVersion(){
					var currentAuditVerionCodeFile =  _.filter(MSF.lists.codeFile,{codType: 'CURRENTAPIVERSIONS',code: 'AUDIT'});
					var currentAuditVerionDetailsJsonObj = {};
					try{
                        currentAuditVerionDetailsJsonObj = JSON.parse(_.get(currentAuditVerionCodeFile,'detailsJson','{}'));
						
					}catch(e){ console.log("AuditService - getCurrentAuditVersion: failed to parse details json ");}
					return _.get(currentAuditVerionDetailsJsonObj,'apiVersion');
				},
				getActiveOrCurrentAuditVersion: function getActiveOrCurrentAuditVersion(performanceContext){
		            var getActiveOrCurrentAuditVersionPromise = $q.defer();
					var url = $location.url();
                   var auditId = service.getAuditId(url);
				   var activeHerd = MSF.getActiveHerd();
				   var activeFarm = MSF.getActiveFarm();

				   var herdId = _.get(activeHerd,'herdId',_.get(activeFarm,'herds[0].herdId'));

				   service.getListByHerdId(performanceContext, function(err,data){
					  var auditlistItem = _.find(data,{AuditId: auditId});

					  var auditVersion = _.get(auditlistItem,'ApiVersion');
					  if(_.isUndefined(auditVersion)){
						  auditVersion = service.getCurrentAuditVersion();
					  }

					  getActiveOrCurrentAuditVersionPromise.resolve(auditVersion);
				   });
                   return getActiveOrCurrentAuditVersionPromise.promise;
				
				},
				getSubHeading: function getSubHeading(subheadding) {
					var lowercase = subheadding.toLowerCase();
					var stringLink = lowercase.replace(/ /g, "-");
					return stringLink;
				},
				getSection: function getSection(link) {
					var linkArr = link.split("/");
					var subHeadingSegment = linkArr[4];
					var codeFile = _.get(MSF.lists,'codeFile',[]);
					var arrSection = _.filter(codeFile, {codeType: 'F360SECTION'});
					for (var index = 0; index < arrSection.length; index++) {
						var segment = arrSection[index].codeValue.toLowerCase().replace(/ /g, "-");
						if (segment === subHeadingSegment) {
							
							return arrSection[index].code;
						}
					}
					return false;	
				},
				checkObjectStoresExist: function checkObjectStoresExist(name){
					return $q(function(resolve, reject){
						var db = indexedDB,
							req;
				
							req = indexedDB.openObjectStore(name);
							req.onsuccess = function () {
								req.result.close();
								resolve(true);
							};
							req.onupgradeneeded = function (evt) {
								evt.target.transaction.abort();
								reject(false);
							};
					
				
					});
				},
				lazyLoadF360DataByFarmId: function lazyLoadF360DataByFarmId(farmId){
					if (window.navigator.onLine) {	
					   lazyLoadF360DataByFarmId(farmId);
					}
				},
				initiallyLoadF360DataByFarmId: function initiallyLoadF360DataByFarmId(farmId){
					
					//var activeFarm = MSF.getActiveFarm();
					if (window.navigator.onLine) {
				    	initiallyLoadF360DataByFarmId(farmId);
					}
					
				},
				
				getList: function getList(personId, performanceContext) {
					if (window.navigator.onLine) {
					  this.checkObjectStoresExist(constant.getList).then(function objectStoresExist(value){
						  // if the object stores exist we don't want to recreate them all again 
						  log.info("object stores already existed.");
						  console.log("object stores already existed.");

						  var activeFarm = MSF.getActiveFarm();
						  lazyLoadF360DataByFarmId(activeFarm.farmId,personId, performanceContext);

						 
					  },function objectStoresDoNotExist(value){

						var activeFarm = MSF.getActiveFarm();
						log.info("object stores did not exist, creating object stores and loading data for farm id: " + activeFarm.farmId);
						console.log("object stores did not exist, creating object stores and loading data for farm id: " + activeFarm.farmId);
						initiallyLoadF360DataByFarmId(activeFarm.farmId, performanceContext);
                        
					 }); // end of check object store exist promise
					
					}
				},
				getOverViewList:  function getOverViewList(auditId, performanceContext, callback) {
					if (window.navigator.onLine) {
						// call api here
						api.getOverViewList(auditId, performanceContext, function getF360OverViewList(apiErr, data) {
							if (apiErr) {
								log.error('error getting overView list: ' + apiErr);
							}

							var overViewListData = [];
							if (data && data.length) {
								var overViewList = Object.values(data[0]);
                                 try{
									overViewListData = JSON.parse(overViewList[0]);
								 }catch(e){
                                    log.error("failed to parse overview list json data from server");
								 }
								 

								indexedDB.readData(constant.getOverViewList, constant.getOverViewList, function getData(readErr, indexDbData) {
									if (readErr) {
										console.error('error in reading getOverViewList objectstore (getOverViewList): ', readErr);
										callbackOrLog(callback, readErr, overViewListData);
									}else{
										if (indexDbData) {

											var foundIndex = indexDbData.findIndex(item => item.auditId == auditId);
										
											var dataUpdate = _.clone(indexDbData);
											if (foundIndex > -1) {
												dataUpdate.splice(foundIndex, 1);
											}


											var overViewLisObjectStoreData = {'auditId': auditId, 'overviewList': overViewList[0]};
											dataUpdate.push(overViewLisObjectStoreData);

											var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getOverViewList, 'keyId' : 'auditId'};
											indexedDB.createObjectStore(constant.getOverViewList, objectStoreNameApi);
											indexedDB.writeData(constant.getOverViewList, objectStoreNameApi,function(writeError,writeData){
                                                if (writeError) {
													console.error('error in writing getOverViewList objectstore (getOverViewList): ', writeError);
												}
													callbackOrLog(callback, writeError, overViewListData);
												
											});
										}else{
											var invalidDataError = "the data returned from the objectstore (getOverViewList) was invalid";
											callbackOrLog(callback, invalidDataError, overViewListData);
										}
									}
								});
							}else{
								callbackOrLog(callback,null, overViewListData);
							}

							
						});
					 } else {
						callbackOrLog(callback, null,  []);
					}
				},
				getIndexedDBOverViewList:  function getIndexedDBOverViewList(auditId, performanceContext, callback) {
					indexedDB.readData(constant.getOverViewList, constant.getOverViewList, function getData(err, data){
						if (err) {
							console.error('error in reading getOverViewList objectstore (getOverViewList): ', err);
							service.getOverViewList(auditId, performanceContext, function(err, apiData){
								
								    var userError = "An error has occurred. Please contact support.";
									callbackOrLog(callback, userError, apiData);
							
								  
							});
						}else{

							if (data) {
								var overviewList = data.filter(item => item.auditId == auditId);
								if (overviewList.length > 0) {
									var overviewListData = JSON.parse(overviewList[0].overviewList);
									callbackOrLog(callback, null, overviewListData || []);
								} else {
								
								    // if the overview list data  for this audit is empty we should check to see if the database has the data and the device is just missing its cached record 	
								    service.getOverViewList(auditId, performanceContext, function(err, apiData){
										var userError = null;
										if(err){
										    userError = "An error has occurred. Please contact support.";
										}

										if(apiData.length > 0){
											callbackOrLog(callback, userError, apiData);
										}else{
											callbackOrLog(callback, userError, []);
										}
										
									  
								    });	
								   
								}
							}else{
								callbackOrLog(callback, null, []);
							}
						}
					});

				},
 
				getPrePopulatedData:  function getPrePopulatedData(auditId, performanceContext, callback) {
					if (window.navigator.onLine) {
						// call api here
						api.getPrePopulatedData(auditId, performanceContext, function getF360PrePopulatedData(err, data) {
							if (err) {
								log.error('error getting PrePopulated Data: ' + err);
							}

							var prePopulatedData = [];
							if (data && data.length) {
								var prePopulatedDataList = Object.values(data[0]);
								try{
									prePopulatedData = JSON.parse(prePopulatedDataList[1]);
									if(_.isNull(prePopulatedData)){
										prePopulatedData = [];
									}
								}catch(e){
									log.error("failed to parse prepopulated data json data from server");
								}
							
								indexedDB.readData(constant.getPrePopulatedData, constant.getPrePopulatedData, function getData(readErr, indexDbData) {
									if (readErr) {
										console.error('error in reading getPrePopulatedData objectstore (getPrePopulatedData): ', readErr);
										callbackOrLog(callback, readErr, prePopulatedData);
									}else{
										var foundIndex = indexDbData.findIndex(item => item.auditId == auditId);
										if (!_.isNull(prePopulatedData) && prePopulatedData.length > 0) {
										var dataUpdate = _.clone(indexDbData);
											if (foundIndex > -1) {
												dataUpdate.splice(foundIndex, 1);
											}
												
											var prePopulatedStoreData = {'auditId': auditId, 'prePopulatedData': JSON.stringify(prePopulatedData)};
											dataUpdate.push(prePopulatedStoreData);

											var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getPrePopulatedData, 'keyId' : 'auditId'};
											indexedDB.createObjectStore(constant.getPrePopulatedData, objectStoreNameApi);
											indexedDB.writeData(constant.getPrePopulatedData, objectStoreNameApi,function(writeError,writeData){
                                                if (writeError) {
													console.error('error in writing getPrePopulatedData objectstore (getPrePopulatedData): ', writeError);
												}
													callbackOrLog(callback, writeError, prePopulatedData);
												
											});
										}else{
											
											callbackOrLog(callback, null, prePopulatedData);
										}
									}
								});
							}else{
								callbackOrLog(callback,null, prePopulatedData);
							}

						
						});
					} else {
						callbackOrLog(callback, null, []);
					
					}
				},
				getIndexedDbPrePopulatedData:  function getIndexedDbPrePopulatedData(auditId, performanceContext, callback) {
					indexedDB.readData(constant.getPrePopulatedData, constant.getPrePopulatedData, function getData(err, data){
						if (err) {
							console.error('error in reading getPrePopulatedData objectstore (getIndexedDbPrePopulatedData): ', err);
							service.getPrePopulatedData(auditId,function(err, apiData){
							
								    var userError = "An error has occurred. Please contact support.";
									callbackOrLog(callback, userError, apiData);
								
								  
							});
						}else{
							if (data) {
								var prePopulatedDataList = data.filter(item => item.auditId == auditId);
								if (prePopulatedDataList.length > 0) {
									
									var prePopulatedData = JSON.parse(prePopulatedDataList[0].prePopulatedData);
									if(_.isNull(prePopulatedData)){
										prePopulatedData = [];
									}
									if(prePopulatedData.length > 0){
										callbackOrLog(callback, null, prePopulatedData || []);
									}else{
										// if the PrePopulated Data  for this audit is empty we should check to see if the database has the data and the device is just missing its cached record 	
										service.getPrePopulatedData(auditId, performanceContext, function(err, apiData){
											var userError = null;
											if(err){
												userError = "An error has occurred. Please contact support.";
											}

											if(apiData.length > 0){
												callbackOrLog(callback, userError, apiData);
											}else{
												callbackOrLog(callback, userError, []);
											}
											
										
										});	
									}								
									
								} else {
									// if the PrePopulated Data  for this audit is empty we should check to see if the database has the data and the device is just missing its cached record 	
								    service.getPrePopulatedData(auditId, performanceContext, function(err, apiData){
										var userError = null;
										if(err){
										    userError = "An error has occurred. Please contact support.";
										}

										if(apiData.length > 0){
											callbackOrLog(callback, userError, apiData);
										}else{
											callbackOrLog(callback, userError, []);
										}
										
									  
								    });
								}
							}else{
								callbackOrLog(callback, null, []);
							}
						}
						
					});
				},
 
				getPenListData:  function getPenListData(auditId,createObjStore, performanceContext, callback) {
					if (window.navigator.onLine) {
						// call api here
						api.getPenListData(auditId, performanceContext, function getF360PenListData(err, data) {
							if (err) {
								log.error('error getting Pen List Data: ' + err);
							}

							var prePopulatedPenList = [];
							if (data && data.length) {
								var penListData = Object.values(data[0]);
								try{
									prePopulatedPenList = JSON.parse(penListData[1]);
									if(_.isNull(prePopulatedPenList)){
										prePopulatedPenList = [];
									}
								}catch(e){
									log.error("failed to parse prepopulated data json data from server");
								}
								
								// if we needed to create the object store, we just do so and return the api data
								 if(createObjStore){

										var penListDataObjectStoreItem  = {'auditId': auditId, 'penListData': JSON.stringify(prePopulatedPenList)};
										var penListDataObjectStoreItems = [penListDataObjectStoreItem];
										
										var objectStoreNameApi = {'data': penListDataObjectStoreItems, 'tableName' : constant.getPenListData, 'keyId' : 'auditId'};
										indexedDB.createObjectStore(constant.getPenListData, objectStoreNameApi);
										indexedDB.writeData(constant.getPenListData, objectStoreNameApi);

										callbackOrLog(callback, null, prePopulatedPenList);
								 }else{

								 
							        // if we didn't need to create the object store , we go through the object store to get the data. 
									indexedDB.readData(constant.getPenListData, constant.getPenListData, function getData(readErr, indexDbData) {
										if (readErr) {
											console.error('error in reading getPenListData objectstore (getPenListData): ', readErr);

											callbackOrLog(callback, readErr, prePopulatedPenList);
										}else{
											var foundIndex = indexDbData.findIndex(item => item.auditId == auditId);
											if (!_.isNull(prePopulatedPenList) && prePopulatedPenList.length > 0) {
											var dataUpdate = _.clone(indexDbData);
												if (foundIndex > -1) {
													dataUpdate.splice(foundIndex, 1);
												}
													
												var penListStoreData = {'auditId': auditId, 'penListData': JSON.stringify(prePopulatedPenList)};
												dataUpdate.push(penListStoreData);

												var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getPenListData, 'keyId' : 'auditId'};
												indexedDB.createObjectStore(constant.getPenListData, objectStoreNameApi);
												indexedDB.writeData(constant.getPenListData, objectStoreNameApi,function(writeError,writeData){
													if (writeError) {
														console.error('error in writing getPenListData objectstore (getPenListData): ', writeError);
													}
														callbackOrLog(callback, writeError, prePopulatedPenList);
													
												});
											}else{
												
												callbackOrLog(callback, null, prePopulatedPenList);
											}
										}
									});
								}
							}else{
								callbackOrLog(callback,null, prePopulatedPenList);
							}

						
						});
					
					} else {
						callbackOrLog(callback, null, []);
					
					}
				},
				getIndexedDbPenListData:  function getIndexedDbPenListData(auditId, performanceContext, callback) {
						
					service.checkObjectStoresExist(constant.getPenListData).then(function objectStoresExist(value){
					    indexedDB.readData(constant.getPenListData, constant.getPenListData, function getData(err, data){
							if (err) {
								console.error('error in reading getPenListData objectstore (getIndexedDbPenListData): ', err);
								service.getPenListData(auditId,true, performanceContext, function(err, apiData){
								
									//  var userError = "An error has occurred. Please contact support.";
									var userError = "";
										callbackOrLog(callback, userError, apiData);
									
									
								});
							}else{
								if (data) {
									var penListDataList = data.filter(item => item.auditId == auditId);
									if (penListDataList.length > 0) {
										
										var penListData = JSON.parse(penListDataList[0].penListData);
										if(_.isNull(penListData)){
											penListData = [];
										}
										if(penListData.length > 0){
											callbackOrLog(callback, null, penListData || []);
										}else{
											// if the Pen List Data  for this audit is empty we should check to see if the database has the data and the device is just missing its cached record 	
											service.getPenListData(auditId, false, performanceContext, function(err, apiData){
												var userError = null;
												if(err){
												//	userError = "An error has occurred. Please contact support.";
												var userError = "";
												}

												if(apiData.length > 0){
													callbackOrLog(callback, userError, apiData);
												}else{
													callbackOrLog(callback, userError, []);
												}
												
											
											});	
										}								
										
									} else {
										// if the Pen List Data  for this audit is empty we should check to see if the database has the data and the device is just missing its cached record 	
										service.getPenListData(auditId,false, performanceContext, function(err, apiData){
											var userError = null;
											if(err){
											var userError = "";
											}

											if(apiData.length > 0){
												callbackOrLog(callback, userError, apiData);
											}else{
												callbackOrLog(callback, userError, []);
											}
											
										
										});
									}
								}else{
									callbackOrLog(callback, null, []);
								}
							}
							
						});
					},function objectStoresDidNotExist(value){

						if (window.navigator.onLine) {
							service.getPenListData(auditId,true, performanceContext, function(err, apiData){
								
								var userError = "";
									callbackOrLog(callback, userError, apiData);
								
								
							});
						}else{
							callbackOrLog(callback, null, []);
						}

					});
				},
				getQuestionList:  function getQuestionList(auditId, performanceContext, callback) {
					if (window.navigator.onLine) {
						api.getQuestionList(auditId, performanceContext, function getF360QuestionList(err, data) {
							if (err) {
								log.error('error getting edit audit data offline mode: ' + err);
							}
							var controlData = [];
							if (data && data.length) {
							    controlData = data[0].QuestionsJson;
								indexedDB.readData(constant.getQuestionList, constant.getQuestionList, function getData(readErr, indexDbData){
									if (readErr) {
										console.error('error in reading getQuestionList data (getQuestionList): ', readErr);
										callbackOrLog(callback, readErr, controlData);
									}else{

										if (indexDbData) {

											var foundIndex = indexDbData.findIndex(item => item.auditId == auditId);
										
											var dataUpdate = _.clone(indexDbData);
											if (foundIndex > -1) {
												dataUpdate.splice(foundIndex, 1);
											}
											var questionListData = {'auditId': auditId, 'questionList': controlData};
											dataUpdate.push(questionListData);

											var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getQuestionList, 'keyId' : 'auditId'};
											indexedDB.createObjectStore(constant.getQuestionList, objectStoreNameApi);
											indexedDB.writeData(constant.getQuestionList, objectStoreNameApi,function(writeError,writeData){
                                                if (writeError) {
													console.error('error in writing getOverViewList objectstore (getQuestionList): ', writeError);
												}
													callbackOrLog(callback, writeError, controlData);
												
											});

										}else{
											var invalidDataError = "the data returned from the objectstore (getQuestionList) was invalid";
											callbackOrLog(callback, invalidDataError, controlData);
										}
								  }
								});

							
							}else{
								callbackOrLog(callback, null, controlData);
							}
						});
					} else {
						callbackOrLog(callback, null,  []);
					}
				},
				getIndexedDBQuestionList: function getIndexedDBQuestionList(auditId, performanceContext, callback){
					indexedDB.readData(constant.getQuestionList, constant.getQuestionList, function getData(err, indexDbData){
						if (err) {
							console.error('error in reading getQuestionList data (getQuestionList): ', err);
							service.getQuestionList(auditId, performanceContext, function(err, apiData){
								
								    var userError = "An error has occurred. Please contact support.";
									callbackOrLog(callback, userError, apiData);
								
								  
							});
						}else{

						
							var controlData = [];
							if (indexDbData) {
								var questionList = indexDbData.filter(item => item.auditId == auditId);
								if (questionList.length > 0) {
									controlData = questionList[0].questionList;
									callbackOrLog(callback, null, controlData || []);
								} else {

									// if the question list data  for this audit is empty we should check to see if the database has the data and the device is just missing its cached record 	
								    service.getQuestionList(auditId, performanceContext, function(err, apiData){
										var userError = null;
										if(err){
										    userError = "An error has occurred. Please contact support.";
										}

										if(apiData.length > 0){
											callbackOrLog(callback, userError, apiData);
										}else{
											callbackOrLog(callback, userError, []);
										}
										
									  
								    });
								}
							}else{
								callbackOrLog(callback, null, []);
							}
						}
					});
				}, 
				getAnswerList:  function getAnswerList(auditId, performanceContext, callback) {
					if (window.navigator.onLine) {
						api.getQuestionList(auditId, performanceContext, function getF360AnswerList(err, data) {
							if (err) {
								log.error('error getting edit audit data offline mode: ' + err);
							}
							
							var controlData = "[]";
							var answerJsonData = _.get(data,'[0].AnswersJson');
							
							if (!_.isUndefined(answerJsonData) && !_.isNull(answerJsonData)) {
								
								controlData = answerJsonData;

								indexedDB.readData(constant.getAnswerList, constant.getAnswerList, function getData(readErr, indexDbData){
									if (readErr) {
										console.error('error in reading getAnswerList data (getAnswerList): ', err);
										callbackOrLog(callback, readErr, controlData);
									}else{

										if (indexDbData) {

											var foundIndex = indexDbData.findIndex(item => item.auditId == auditId);
										
											var dataUpdate = _.clone(indexDbData);
											if (foundIndex > -1) {
												dataUpdate.splice(foundIndex, 1);
											}
			

											var answerListData = {'auditId': auditId, 'answerList': controlData};
											dataUpdate.push(answerListData);

											var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getAnswerList, 'keyId' : 'auditId'};
											indexedDB.createObjectStore(constant.getAnswerList, objectStoreNameApi);
											indexedDB.writeData(constant.getAnswerList, objectStoreNameApi,function(writeError,writeData){
                                                if (writeError) {
													console.error('error in writing getOverViewList objectstore (getAnswerList): ', writeError);
												}
													callbackOrLog(callback, writeError, controlData);
												
											});
										}else{
											var invalidDataError = "the data returned from the objectstore (getAnswerList) was invalid";
											callbackOrLog(callback, invalidDataError, controlData);
										}
							        }
								});

							
							}else{
								callbackOrLog(callback, null, controlData);
							}
						});
					} else {
						callbackOrLog(callback, null,  "[]");
					}
				},
				getIndexedDBAnswerList: function getIndexedDBAnswerList(auditId, performanceContext, callback){
						indexedDB.readData(constant.getAnswerList, constant.getAnswerList, function getData(err, data){
							if (err) {
								console.error('error in reading getAnswerList data (getAnswerList): ', err);
								service.getAnswerList(auditId, performanceContext, function(err, apiData){
								
										var userError = "An error has occurred. Please contact support.";
										callbackOrLog(callback, userError, apiData);
								
									  
								});
							}else{
								var controlData = "[]";
								if (_.isArray(data) && data.length > 0) {
									var getAnswerList = data.filter(item => item.auditId == auditId);
									if (getAnswerList.length > 0) {
										controlData = getAnswerList[0].answerList;
										callbackOrLog(callback, null, controlData || "[]");
									}
									else {
										// if the answer list data  for this audit is empty we should check to see if the database has the data and the device is just missing its cached record 	
										service.getAnswerList(auditId, performanceContext, function(err, apiData){
											var userError = null;
											if(err){
												userError = "An error has occurred. Please contact support.";
											}
	
											if(apiData.length > 0){
												callbackOrLog(callback, userError, apiData);
											}else{
												callbackOrLog(callback, userError, "[]");
											}
											
										  
										});
									}
								}else{
									callbackOrLog(callback, null, controlData);
								}
							}
						});
				},
				getReviewResultsAndDraft:  function getReviewResultsAndDraft(auditId, performanceContext, callback) {
					if (window.navigator.onLine) {
						api.getReviewResultsAndDraft(auditId, performanceContext, function getF360ReviewResultsAndDraft(err, data) {
							if (err) {
								log.error('error getting edit audit data offline mode: ' + err);
							}
							var controlData = {}
							if (data && data.length) {
								 controlData = _.get(data[0],'DraftNotesJson',{});
								 if(_.isNull(controlData)){
									 controlData = {};
								 }
								indexedDB.readData(constant.getReviewResultsAndDraft, constant.getReviewResultsAndDraft, function getData(readErr, indexDbData){
									if (readErr) {
										console.error('error in reading getReviewResultsAndDraft data (getReviewResultsAndDraft): ', readErr);
										callbackOrLog(callback, readErr, controlData);
									}else{

										if (indexDbData) {


											var foundIndex = indexDbData.findIndex(item => item.auditId == auditId);
										
											var dataUpdate = _.clone(indexDbData);
											if (foundIndex > -1) {
												dataUpdate.splice(foundIndex, 1);
											}

											var reviewResultsAndDraftData = {'auditId': auditId, 'reviewResultsAndDraft': controlData};
											dataUpdate.push(reviewResultsAndDraftData);

											var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getReviewResultsAndDraft, 'keyId' : 'auditId'};
											indexedDB.createObjectStore(constant.getReviewResultsAndDraft, objectStoreNameApi);
											indexedDB.writeData(constant.getReviewResultsAndDraft, objectStoreNameApi,function(writeError,writeData){
                                                if (writeError) {
													console.error('error in writing getOverViewList objectstore (getReviewResultsAndDraft): ', writeError);
												}
													callbackOrLog(callback, writeError, controlData);
												
											});
										}else{
											var invalidDataError = "the data returned from the objectstore (getReviewResultsAndDraft) was invalid";
											callbackOrLog(callback, invalidDataError, controlData);
										}
									}
								});

							
							}else{
								callbackOrLog(callback, null, controlData);
							}
						});
					} else {
						callbackOrLog(callback, null,  []);
					}
				},
				getIndexedDBReviewResultsAndDraft:  function getIndexedDBReviewResultsAndDraft(auditId, performanceContext, callback) {
					indexedDB.readData(constant.getReviewResultsAndDraft, constant.getReviewResultsAndDraft, function getData(err, indexDbData){
						if (err) {
							console.error('error in reading getReviewResultsAndDraft data (getReviewResultsAndDraft): ', err);
							service.getReviewResultsAndDraft(auditId, performanceContext, function(err, apiData){
							
									var userError = "An error has occurred. Please contact support.";
									callbackOrLog(callback, userError, apiData);
							
								  
							});
						}else{
							var controlData = [];
							if (indexDbData) {
								var reviewResultsAndDraftData = indexDbData.filter(item => item.auditId == auditId);
								if (reviewResultsAndDraftData.length > 0) {
									controlData = reviewResultsAndDraftData[0].reviewResultsAndDraft;
									callbackOrLog(callback, null, controlData || []);
								} else {
									// if the answer list data  for this audit is empty we should check to see if the database has the data and the device is just missing its cached record 	
									service.getReviewResultsAndDraft(auditId, performanceContext, function(err, apiData){
										var userError = null;
										if(err){
											userError = "An error has occurred. Please contact support.";
										}

										if(apiData.length > 0){
											callbackOrLog(callback, userError, apiData);
										}else{
											callbackOrLog(callback, userError, []);
										}
										
									  
									});
								}
							}else{
								callbackOrLog(callback, null, controlData);
							}
						}
					});
				},
				updateCachedAuditDisplayFields: function updateCachedAuditDisplayFields(audit){
					// first we need to check if the getList object store exists and if it does then update the cached audit display fields
					 this.checkObjectStoresExist(constant.getList).then(function objectStoresExist(value){
						// audit is only from sql when the device is online , so there is no need to update the cached audit display fields when offline
						if (window.navigator.onLine && !_.isUndefined(audit) ) {
							indexedDB.readData(constant.getList, constant.getList, function getData(err, indexDbData){
								if (err) {
									console.error('error in reading getList data (getListByHerdId): ', err);
								}
								if (indexDbData && indexDbData.length) {
								
									var indexedDBHerdAuditListItem = _.find(indexDbData, {herdId: _.get(audit,'HerdId')});
									var foundIndex = indexDbData.findIndex(item => item.herdId == _.get(audit,'HerdId'));	
									if(!_.isUndefined(indexedDBHerdAuditListItem)){
									
										
										var dataUpdate = _.clone(indexDbData);
										if (foundIndex > -1) {
											dataUpdate.splice(foundIndex, 1);
										}
										var auditList = JSON.parse(_.get(indexedDBHerdAuditListItem,'auditList'));
										var cachedAudit = _.find(auditList, {AuditId: _.get(audit,'AuditId')});

										var foundAuditIndex = auditList.findIndex(item => item.auditId == _.get(audit,'AuditId'));
										if (foundAuditIndex > -1) {
											auditList.splice(foundAuditIndex, 1);
										}
										

										if(!_.isUndefined(cachedAudit)){
											_.set(cachedAudit,'CheckedOutTo',_.get(audit,'CheckedOutTo'));
											_.set(cachedAudit,'Authors',_.get(audit,'Authors'));
										}else{
											auditList.push(audit);
										}
										var updatedIndexedDBHerdAuditListItem = {'herdId': _.get(audit,'HerdId'), 'auditList': JSON.stringify(auditList)};
										dataUpdate.push(updatedIndexedDBHerdAuditListItem);
										
										var getListObjectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getList, 'keyId' : 'herdId'};
										indexedDB.createObjectStore(constant.getList, getListObjectStoreNameApi);
										indexedDB.writeData(constant.getList, getListObjectStoreNameApi);

									}
									
									
								}
							});  
						} 
				 });
				        
				},
				getListByHerdId: function getListByHerdId(performanceContext, callback) {
				  try{	
					if (window.navigator.onLine) {
						var currentHerd = MSF.getActiveHerd();
						api.getListByHerdId(currentHerd.herdId, performanceContext, function getF360ListByHerdId(err, data) {
							if (err) {
								log.error('error getting F360 list by herdId: ' + err);
							}

							if (data) {
								callbackOrLog(callback, null, data || null);
							}
						});
					} else {
						indexedDB.readData(constant.getList, constant.getList, function getData(err, data){
							if (err) {
								console.error('error in reading getList data (getListByHerdId): ', err);
							}
							if (data && data.length) {
								var currentHerd = MSF.getActiveHerd();
								var auditData = _.find(data, {herdId: currentHerd.herdId});
								if (auditData) {
									var auditList = JSON.parse(auditData.auditList);
									callbackOrLog(callback, null, auditList || null);
								} else {
									callbackOrLog(callback, null, []);
								}
								
								
							}
						});
					}
				}catch(e){
					callbackOrLog(callback,_.get(e,'message',"error in getting audit list"),[]);
				}
				},
				getIndexDBListByHerdId: function getIndexDBListByHerdId(callback) {

					try{

						

					
						indexedDB.readData(constant.getList, constant.getList, function getData(err, data){
							if (err) {
								console.log('error in reading getList data (getIndexDBListByHerdId): ', err);
							}
							if (data && data.length) {
								var currentHerd = MSF.getActiveHerd();
								var auditData = _.find(data, {herdId: currentHerd.herdId});
								if (auditData) {
									var auditList = JSON.parse(auditData.auditList);
									callbackOrLog(callback, null, auditList || null);
								} else {
									callbackOrLog(callback, null, []);
								}
								
								
							}else{
								callbackOrLog(callback, err, []);
							}
						});
					}catch(e){
						callbackOrLog(callback,_.get(e,'message',"error in reading getList object store"),[]);
					}
					
				},
				getHerdsByFarmId: function getHerdsByFarmId(farmId,callback) {
					if (window.navigator.onLine) {
						
						api.getHerdsByFarmId(farmId, function getF360HerdsByFarmId(err, herds) {
							if (err) {
								log.error('Failed to get herds by farmId.' + err);
							}
							var listherds = [];
							if (herds) {
								listherds.push(herds[0]);
								callbackOrLog(callback, null, listherds || null);
							}
						});
					} else {
						indexedDB.readData(constant.getListherds, constant.getListherds, function getData(err, data){
							if (err) {
								console.log('err', err);
							}
							if (data && data.length) {
								var listherds = [];
								var herd = _.find(data, {farmId: farmId});
								if (herd) {
									listherds.push(herd);
								
									callbackOrLog(callback, null, listherds || null);
								} else {
									callbackOrLog(callback, null, []);
								}
								
								
							}
						});
					}
				},
				getHerdFertilityProgramsByHerdId: function getHerdFertilityProgramsByHerdId(performanceContext, callback) {
					if (window.navigator.onLine) {
						api.getHerdFertilityProgramsByHerdId(MSF.getActiveHerd().herdId, performanceContext, function programsGotten(err, data) {
							if (err) {
								log.error('error getting herd fertility programs by herdId: ' + err);
							}

							var objectStoreNameApi = {'data': data, 'tableName' : constant.getPrograms, 'keyId' : 'herdFertilityProgramId'};
							indexedDB.createObjectStore(constant.getPrograms, objectStoreNameApi);
							indexedDB.writeData(constant.getPrograms, objectStoreNameApi);

							if (data) {
								callbackOrLog(callback, null, data[0] || null);
							}
						});
					} else {
						indexedDB.readData(constant.getPrograms, constant.getPrograms, function getData(err, data) {
							if (err) {
								console.log('err', err);
							}
							if (data) {
								callbackOrLog(callback, null, data[0] || null);
							}
						});
					}
				},
				updateAuditSectionsData: function getUpdateAuditSectionsData(auditId, overviewListJson,callback){

					// we want to start by getting the overview list in indexedDB , because we are going to be updating this audit's entry with the passed in json
					 indexedDB.readData(constant.getOverViewList, constant.getOverViewList, function getData(err, indexedDBOverviewListData){
						 if (err) {
							console.error('error in reading getOverViewList objectstore (updateAuditSectionsData): ', err);
						 }
						 if (indexedDBOverviewListData && indexedDBOverviewListData.length) {
 
							 var foundIndex = indexedDBOverviewListData.findIndex(item => item.auditId == auditId);
							 
							  if(overviewListJson && overviewListJson.length > 0){
									  
								 //if this audit's overview list data was found and we are here because actual overviewlist json was passed in
								 // we first clone the the list of all audit's overview list indexedb data
								 
								 var dataUpdate = _.clone(indexedDBOverviewListData);
								  if (foundIndex > -1) {
									   dataUpdate.splice(foundIndex, 1);
								  }
								 
									 var overViewListData = {'auditId': auditId, 'overviewList': overviewListJson};
									 dataUpdate.push(overViewListData);
 
									 var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getOverViewList, 'keyId' : 'auditId'};
									 indexedDB.createObjectStore(constant.getOverViewList, objectStoreNameApi);
									 indexedDB.writeData(constant.getOverViewList, objectStoreNameApi);
									 
									 if(window.navigator.onLine){
										   
										 api.updateAuditSectionsData(auditId,overviewListJson,function(err, data){
												
											 if (err) {
												console.error("error updating an audit's Sections data: ", err);
												 callbackOrLog(callback, err, []);	
											 }else{
												 callbackOrLog(callback, null, data || null);			
											 }
 
											 
										 });
 
									 }else{
										 callbackOrLog(callback, null, []);	
									 }
 
									 
							 
							 }else{
								 callbackOrLog(callback, null, []);	
							 }
								 
								 
							 
						 }else{
							 callbackOrLog(callback, null, []);
						 }
					 });
			 
			 
				 },
				updateIndexedDbPrePopulatedData:  function updateIndexedDbPrePopulatedData(auditId,prePopulatedDataJson, callback) {
					indexedDB.readData(constant.getPrePopulatedData, constant.getPrePopulatedData, function getData(err, data){
						if (err) {
							console.error('error in reading getPrePopulatedData objectstore (updateIndexedDbPrePopulatedData): ', err);
						}
						var foundIndex = data.findIndex(item => item.auditId == auditId);
						if (!_.isNull(prePopulatedDataJson) && !_.isUndefined() && prePopulatedDataJson.length > 0) {
							var dataUpdate = _.clone(data);
							if (foundIndex > -1) {
								dataUpdate.splice(foundIndex, 1);
							}
								
							var prePopulatedStoreData = {'auditId': auditId, 'prePopulatedData': prePopulatedDataJson};
							dataUpdate.push(prePopulatedStoreData);

							var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getPrePopulatedData, 'keyId' : 'auditId'};
							indexedDB.createObjectStore(constant.getPrePopulatedData, objectStoreNameApi);
							indexedDB.writeData(constant.getPrePopulatedData, objectStoreNameApi);
						}
					});
				},
				updateIndexedDbPenListData:  function updateIndexedDbPenListData(auditId,penListDataJson, callback) {
					indexedDB.readData(constant.getPenListData, constant.getPenListData, function getData(err, data){
						if (err) {
							console.error('error in reading getPenListData objectstore (updateIndexedDbPenListData): ', err);
						}
						var foundIndex = data.findIndex(item => item.auditId == auditId);
						if (!_.isNull(penListDataJson) && !_.isUndefined() && penListDataJson.length > 0) {
							var dataUpdate = _.clone(data);
							if (foundIndex > -1) {
								dataUpdate.splice(foundIndex, 1);
							}
								
							var penListStoreData = {'auditId': auditId, 'penListData': penListDataJson};
							dataUpdate.push(penListStoreData);

							var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getPenListData, 'keyId' : 'auditId'};
							indexedDB.createObjectStore(constant.getPenListData, objectStoreNameApi);
							indexedDB.writeData(constant.getPenListData, objectStoreNameApi);
						}
					});
				},
				updateDeviceAuditData: function updateDeviceAuditData(auditId, performanceContext,callback){

					var answerPromise = $q.defer();
					var reviewDraftPromise = $q.defer();
					var prePopulatedPromise = $q.defer();
					var penListPromise = $q.defer();
					var listPromise = $q.defer();
					var overviewListPromise = $q.defer();


					  // overview list data

					  api.getOverViewList(auditId, performanceContext, function getF360OverViewList(err, data) {
						if (err) {
							log.error('error getting overView list: ' + err);
						    overviewListPromise.resolve(false);
						}

					
						if (data && data.length) {
							var overViewList = Object.values(data[0]);

							indexedDB.readData(constant.getOverViewList, constant.getOverViewList, function getData(err, indexDbData) {
								if (err) {
									console.error('error in reading getOverViewList objectstore (updateDeviceAuditData): ', err);
									overviewListPromise.resolve(false);
								}


								var foundIndex = indexDbData.findIndex(item => item.auditId == auditId);
									
								var dataUpdate = _.clone(indexDbData);
								if (foundIndex > -1) {
									dataUpdate.splice(foundIndex, 1);
								}


								if (dataUpdate) {
									var overViewListData = {'auditId': auditId, 'overviewList': overViewList[0]};
									dataUpdate.push(overViewListData);

									var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getOverViewList, 'keyId' : 'auditId'};
									indexedDB.createObjectStore(constant.getOverViewList, objectStoreNameApi);
									indexedDB.writeData(constant.getOverViewList, objectStoreNameApi);
									overviewListPromise.resolve(true);
								}else{
									overviewListPromise.resolve(true);
								}
							});
						}else{
							overviewListPromise.resolve(true);
						}

					
					});

						// get Answer Data 
						
						api.getQuestionList(auditId, performanceContext, function getF360QuestionList(err, questionListdata) {
							if (err) {
								log.error('error getting edit audit data offline mode: ' + err);
								answerPromise.resolve(false);
							}
							if (questionListdata && questionListdata.length > 0) {

								indexedDB.readData(constant.getAnswerList, constant.getAnswerList, function getData(err, data){
									if (err) {
										console.error('error in reading getAnswerList objectstore (updateDeviceAuditData): ', err);
										answerPromise.resolve(false);
									}
										var foundIndex = data.findIndex(item => item.auditId == auditId);
									
											var dataUpdate = _.clone(data);
											if (foundIndex > -1) {
												dataUpdate.splice(foundIndex, 1);
											}

											var answerListData = {'auditId': auditId, 'answerList': questionListdata[0].AnswersJson};
											dataUpdate.push(answerListData);

											var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getAnswerList, 'keyId' : 'auditId'};
											indexedDB.createObjectStore(constant.getAnswerList, objectStoreNameApi);
											indexedDB.writeData(constant.getAnswerList, objectStoreNameApi);
										answerPromise.resolve(true);	
										
								});
								
							}else{
								answerPromise.resolve(true);	
							}
						});

						// get Results and Write , Review Draft Data
						api.getReviewResultsAndDraft(auditId, performanceContext, function getF360ReviewResultsAndDraft(err, reviewResultsAndDraftData) {
							if (err) {
								log.error('error getting PrePopulated Data During device update: ' + err);
								reviewDraftPromise.resolve(false);
							}
							
							if (reviewResultsAndDraftData && reviewResultsAndDraftData.length) {
								var reviewResultsAndDraftDataList = _.get(reviewResultsAndDraftData[0],'DraftNotesJson',{});

								indexedDB.readData(constant.getReviewResultsAndDraft, constant.getReviewResultsAndDraft, function getData(err, data){
									if (err) {
										console.error('error in reading getReviewResultsAndDraft objectstore (updateDeviceAuditData): ', err);
										reviewDraftPromise.resolve(false);
									}
									if (data && data.length) {
										var foundIndex = data.findIndex(item => item.auditId == auditId);
									
											var dataUpdate = _.clone(data);
											if (foundIndex > -1) {
												dataUpdate.splice(foundIndex, 1);
											}
			
											var reviewResultsAndDraftStoreData = {'auditId': auditId, 'reviewResultsAndDraft': reviewResultsAndDraftDataList};
											dataUpdate.push(reviewResultsAndDraftStoreData);
			
											var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getReviewResultsAndDraft, 'keyId' : 'auditId'};
											indexedDB.createObjectStore(constant.getReviewResultsAndDraft, objectStoreNameApi);
											indexedDB.writeData(constant.getReviewResultsAndDraft, objectStoreNameApi);
											reviewDraftPromise.resolve(true);
										
									}else{
										reviewDraftPromise.resolve(true);	
									}
								});
									
							}else{
								reviewDraftPromise.resolve(true);
							}
						});

						api.getPrePopulatedData(auditId, performanceContext, function getF360PrePopulatedData(err, data) {
							if (err) {
								log.error('error getting PrePopulated Data: ' + err);
								prePopulatedPromise.resolve(false);
							}

							var prePopulatedData = [];
							if (data && data.length) {
								var prePopulatedDataList = Object.values(data[0]);
								prePopulatedData = JSON.parse(prePopulatedDataList[1]);
								if(_.isNull(prePopulatedData)){
									prePopulatedData = [];
								}

								indexedDB.readData(constant.getPrePopulatedData, constant.getPrePopulatedData, function getData(err, indexDbData) {
									if (err) {
										console.error('error in reading getPrePopulatedData objectstore (updateDeviceAuditData): ', err);
										prePopulatedPromise.resolve(false);
									}
									var foundIndex = indexDbData.findIndex(item => item.auditId == auditId);
							        if (!_.isNull(prePopulatedData) && prePopulatedData.length > 0) {
								       var dataUpdate = _.clone(indexDbData);
										if (foundIndex > -1) {
											dataUpdate.splice(foundIndex, 1);
										}
											
										var prePopulatedStoreData = {'auditId': auditId, 'prePopulatedData': JSON.stringify(prePopulatedData)};
										dataUpdate.push(prePopulatedStoreData);

										var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getPrePopulatedData, 'keyId' : 'auditId'};
										indexedDB.createObjectStore(constant.getPrePopulatedData, objectStoreNameApi);
										indexedDB.writeData(constant.getPrePopulatedData, objectStoreNameApi);

										prePopulatedPromise.resolve(true);
									}else{
										prePopulatedPromise.resolve(true);
									}
								});
							}else{
								prePopulatedPromise.resolve(true);
							}

						
						});

						api.getPenListData(auditId, performanceContext, function getF360PenListData(err, data) {
							if (err) {
								log.error('error getting Pen List Data: ' + err);
								penListPromise.resolve(false);
							}

							var prePopulatedPenList = [];
							if (data && data.length) {
								var penListData = Object.values(data[0]);
								try{
									prePopulatedPenList = JSON.parse(penListData[1]);
									if(_.isNull(prePopulatedPenList)){
										prePopulatedPenList = [];
									}
								}catch(e){
									log.error("failed to parse prepopulated data json data from server");
								}

								indexedDB.readData(constant.getPenListData, constant.getPenListData, function getData(err, penListIndexDbData) {
									if (err) {
										console.error('error in reading getPenListData objectstore (updateDeviceAuditData): ', err);
										penListPromise.resolve(false);
									}
									var foundIndex = penListIndexDbData.findIndex(item => item.auditId == auditId);
							        if (!_.isNull(penListData) && penListData.length > 0) {
								       var dataUpdate = _.clone(penListIndexDbData);
										if (foundIndex > -1) {
											dataUpdate.splice(foundIndex, 1);
										}
											
										var prePopulatedStoreData = {'auditId': auditId, 'penListData': JSON.stringify(prePopulatedPenList)};
										dataUpdate.push(prePopulatedStoreData);

										var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getPenListData, 'keyId' : 'auditId'};
										indexedDB.createObjectStore(constant.getPenListData, objectStoreNameApi);
										indexedDB.writeData(constant.getPenListData, objectStoreNameApi);

										penListPromise.resolve(true);
									}else{
										penListPromise.resolve(true);
									}
								});
							}else{
								penListPromise.resolve(true);
							}

						
						});

						 // update getList here
					
										
						   var currentHerd = MSF.getActiveHerd();
							api.getListByHerdId(currentHerd.herdId, performanceContext, function getF360ListByHerdId(err, serverListData) {
								if (err) {
									log.error('error getting F360 list by herdId: ' + err);
									listPromise.resolve(false);
								}
								if (serverListData && serverListData.length) {
									// when getList is first initialized all audit list items need IsDeviceDirty = false
									_.forEach(serverListData,function(auditListItem){
									_.set(auditListItem,'IsDeviceDirty',_.get(auditListItem,'IsDeviceDirty',false));
			
									});


									indexedDB.readData(constant.getList, constant.getList, function getData(err, data){
										if (err) {
											console.error('error in reading getList objectstore (updateDeviceAuditData): ', err);
											listPromise.resolve(false);
										}
				
										if (data && data.length) {
				
										
				
											var foundIndex = data.findIndex(item => item.herdId == currentHerd.herdId);
											var dataUpdate = _.clone(data);
				
							
				
											if (foundIndex > -1) {
											   dataUpdate.splice(foundIndex, 1);														
											}

											var stringAuditList = JSON.stringify(serverListData);
											var auditList = {'herdId': currentHerd.herdId, 'auditList': stringAuditList};
											dataUpdate.push(auditList);
					
											var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getList, 'keyId' : 'herdId'};
											indexedDB.createObjectStore(constant.getList, objectStoreNameApi);
											indexedDB.writeData(constant.getList, objectStoreNameApi);
					
											listPromise.resolve(true);
										}else{
											listPromise.resolve(false);
										}
				
									});
										
								}else{
									   listPromise.resolve(true);
									}
			
								});
					  
					  

					   
					$q.all([answerPromise.promise, reviewDraftPromise.promise,prePopulatedPromise.promise,penListPromise.promise, listPromise.promise,overviewListPromise.promise]).then(function(result){
						if(_.all(result,function(value){return value;})){
							callbackOrLog(callback, null, []); 
						}else{
							callbackOrLog(callback, "One of the updates to the device failed", []);
						}
							
					});

				},
				updateServerAuditData: function updateServerAuditData(auditId,callback){
					var answerPromise = $q.defer();
					var reviewDraftPromise = $q.defer();
					var listPromise = $q.defer();
					var overviewListPromise = $q.defer();
				  

							//update overview list per sections' data
							indexedDB.readData(constant.getOverViewList, constant.getOverViewList, function getData(err, data){
								if (err) {
									console.error('error in reading getOverViewList objectstore (updateServerAuditData): ', err);
									overviewListPromise.resolve(false);
								}
								var OverviewListJson = [];
								if (data && data.length) {
									var getOverViewList = data.filter(item => item.auditId == auditId);
									if (getOverViewList.length > 0) {
										OverviewListJson = getOverViewList[0].overviewList;

										api.updateAuditSectionsData(auditId, OverviewListJson, function getF360UpdateAuditSectionsData(err, data) {
											if (err) {
												log.error('error updating OverviewList during updateServerAuditData: ' + err);
												overviewListPromise.resolve(false);
											}else{
												overviewListPromise.resolve(true);
											} 
											 
										
										});
									}else{
										overviewListPromise.resolve(true);
									}

								}else{
									overviewListPromise.resolve(true);
								}
							});

							
							//update answers data
							indexedDB.readData(constant.getAnswerList, constant.getAnswerList, function getData(err, data){
								if (err) {
									console.error('error in reading getAnswerList objectstore (updateServerAuditData): ', err);
									answerPromise.resolve(false);
								}
								var AnswersJson = [];
								if (data && data.length) {
									var getAnswerList = data.filter(item => item.auditId == auditId);
									if (getAnswerList.length > 0) {
										AnswersJson = getAnswerList[0].answerList;
									

										api.updateAnswer(auditId, AnswersJson, function getF360UpdateAnswer(err, data) {
											if (err) {
												log.error('error updating AnswerList during updateServerAuditData: ' + err);
												answerPromise.resolve(false);
											}else{
												answerPromise.resolve(true);
											} 
											 
									
										});
									}else{
										answerPromise.resolve(true);
									}

								}else{
									answerPromise.resolve(true);
								}
							});
			
			   
				
							// update Results and Write , Review Draft Data
							indexedDB.readData(constant.getReviewResultsAndDraft, constant.getReviewResultsAndDraft, function getData(err, indexDbData){
								if (err) {
									console.error('error in reading getReviewResultsAndDraft objectstore (updateServerAuditData): ', err);
								reviewDraftPromise.resolve(false);
								}
								var draftNotesJson = [];
								if (indexDbData && indexDbData.length) {
									var reviewResultsAndDraftData = indexDbData.filter(item => item.auditId == auditId);
									if (reviewResultsAndDraftData.length > 0) {
										draftNotesJson = reviewResultsAndDraftData[0].reviewResultsAndDraft;

										var draftNotesJsonData = _.clone(JSON.parse(draftNotesJson));
										var nextEvalDate = _.get(draftNotesJsonData,'resultsWriteRptJson.nextEvaluationDate',moment().add('days', 180).toDate());
										
										api.updateReviewResults(auditId, draftNotesJson,nextEvalDate, function getF360ReviewResultsAndDraft(err, data) {
											if (err) {
												log.error('error updating ReviewResultsAndDraft during updateServerAuditData: ' + err);
												reviewDraftPromise.resolve(false);
											}else{
												reviewDraftPromise.resolve(true);
											}
									
										});	


									}else{
										reviewDraftPromise.resolve(true);
									} 
								}else{
									reviewDraftPromise.resolve(true);
								}
							});
	
			   
			
							// need to update data from getList here
							indexedDB.readData(constant.getList, constant.getList, function getData(err, data){
								if (err) {
									console.error('error in reading getList objectstore (updateServerAuditData): ', err);
								    listPromise.resolve(false);
								}

								if (data && data.length) {

									var currentHerd = MSF.getActiveHerd();

									var foundIndex = data.findIndex(item => item.herdId == currentHerd.herdId);
									var dataUpdate = _.clone(data);

									
									var auditData = _.find(dataUpdate, {herdId: currentHerd.herdId});

									if (auditData) {
										var auditList = JSON.parse(auditData.auditList);

										var activeAudit = _.find(auditList,{AuditId:auditId});
										if(activeAudit){


										if(_.isEqual(_.get(activeAudit,'Deleted'),true)){
											api.deleteAuditbyAuditId(_.get(activeAudit,'AuditId'), function deleteAuditbyAuditId(err, data) {
												if (err) {
													log.error('error delete audit: ' + err);
													listPromise.resolve(false);
												}else{
													listPromise.resolve(true);
												}
																							
											});

										}else{
											if(!_.isNull(_.get(activeAudit,'PublishedOn'))){
												
												indexedDB.readData(constant.getReviewResultsAndDraft, constant.getReviewResultsAndDraft, function getData(err, indexDbData){
													if (err) {
														console.error('error in reading getReviewResultsAndDraft objectstore (updateServerAuditData): ', err);
														listPromise.resolve(false);
													}
													var draftNotesJson = [];
													if (indexDbData && indexDbData.length) {
														var reviewResultsAndDraftData = indexDbData.filter(item => item.auditId == auditId);
														if (reviewResultsAndDraftData.length > 0) {
															draftNotesJson = reviewResultsAndDraftData[0].reviewResultsAndDraft;
					
																									
															api.publishAudit(_.get(activeAudit,'AuditId'), draftNotesJson, function publishF360Audit(err, data) {
																if (err) {
																	log.error('error getting overView list: ' + err);
																	listPromise.resolve(false);
																}else{
																	listPromise.resolve(true);
																}
															
															});
					
					
														}else{
															listPromise.resolve(true);
														} 
													}else{
														listPromise.resolve(true);
													}
												});	
													
											}else{
												listPromise.resolve(true);
											}
										}

											
									
											
										}else{
											listPromise.resolve(false);
										}
										
									}else{
										listPromise.resolve(false);
									} 
								
								}else{
									listPromise.resolve(false);
								}

							});
		

				 $q.all([answerPromise.promise, reviewDraftPromise.promise, listPromise.promise,overviewListPromise.promise]).then(function(result){
					if(_.all(result,function(value){return value;})){
						callbackOrLog(callback, null, []); 
					}else{
						callbackOrLog(callback, "One of the updates to the server failed", []);
					}
						
				});

					
				},
				updateIsDirty : function updateIsDirty(auditId,isDirty,callback){
					try {
					indexedDB.readData(constant.getList, constant.getList, function getData(err, data){
						if (err) {
							console.error('error in reading getList objectstore (updateIsDirty): ', err);
						}

						if (data && data.length) {

							var currentHerd = MSF.getActiveHerd();

							var foundIndex = data.findIndex(item => item.herdId == currentHerd.herdId);
							var dataUpdate = _.clone(data);

							
							var auditData = _.find(dataUpdate, {herdId: currentHerd.herdId});

							if (auditData) {
								var auditList = JSON.parse(auditData.auditList);

								var activeAudit = _.find(auditList,{AuditId:auditId});
								if(activeAudit){

									if (foundIndex > -1) {
										dataUpdate.splice(foundIndex, 1);
									 
									}
									if(_.isUndefined(isDirty)){
										isDirty = false;
									}
									_.set(activeAudit,'IsDeviceDirty',isDirty);
									
									var auditListData = {'herdId': currentHerd.herdId, 'auditList': JSON.stringify(auditList)};
									dataUpdate.push(auditListData);

									var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getList, 'keyId' : 'herdId'};
								    indexedDB.createObjectStore(constant.getList, objectStoreNameApi);
									indexedDB.writeData(constant.getList, objectStoreNameApi);

									
								   callbackOrLog(callback, null, []);
									
								}else{
									callbackOrLog(callback, "audit could not be found in this current herd's audit list", []);
								}
								
							}else{
								callbackOrLog(callback, "audit list was not found with herdId of "+currentHerd.herdId, []);
							} 
						
						}else{
							callbackOrLog(callback, "no data returned from getList objectstore", []);
						}

					});
				  }catch(e){
					callbackOrLog(callback,_.get(e,'message',"error in updating isDirty"),[]);
				  }
				},
				updateLastSyncedDate: function updateLastSyncedDate(auditId,syncedOn,callback){
				 
					try{
					
					indexedDB.readData(constant.getList, constant.getList, function getData(err, data){
						if (err) {
							console.error('error in reading getList objectstore (updateLastSyncedDate): ', err);
						}
						if (data && data.length) {

							var currentHerd = MSF.getActiveHerd();

							var foundIndex = data.findIndex(item => item.herdId == currentHerd.herdId);
							var dataUpdate = _.clone(data);

							
							var auditData = _.find(dataUpdate, {herdId: currentHerd.herdId});

							if (auditData) {
								var auditList = JSON.parse(auditData.auditList);

								var activeAudit = _.find(auditList,{AuditId:auditId});
								if(activeAudit){

									if (foundIndex > -1) {
										dataUpdate.splice(foundIndex, 1);
									 
									}
									

									_.set(activeAudit,'SyncedOn',syncedOn);
								
									

									var auditListData = {'herdId': currentHerd.herdId, 'auditList': JSON.stringify(auditList)};
									dataUpdate.push(auditListData);

									var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getList, 'keyId' : 'herdId'};
								    indexedDB.createObjectStore(constant.getList, objectStoreNameApi);
									indexedDB.writeData(constant.getList, objectStoreNameApi);

										callbackOrLog(callback, null, []);
	

								}else{
									callbackOrLog(callback, null, []);
								}

								
							}else{
								callbackOrLog(callback, null, []);
							} 

							
							
						}else{
							callbackOrLog(callback, null, []);
						}
					});

					}catch(e){
						callbackOrLog(callback,_.get(e,'message',"error in updating last sync date"),[]);
					}	

				}, 
				updateAnswer: function updateAnswer(auditId, AnswersJson, callback) {
					indexedDB.readData(constant.getAnswerList, constant.getAnswerList, function getData(err, data){
						if (err) {
							console.error('error in reading getAnswerList data (updateAnswer): ', err);
						}
						if (data && data.length) {
							var foundIndex = data.findIndex(item => item.auditId == auditId);
							if (AnswersJson.length > 0) {
								var dataUpdate = _.clone(data);
								if (foundIndex > -1) {
									dataUpdate.splice(foundIndex, 1);
								}

								var answerData = {'auditId': auditId, 'answerList': AnswersJson};
								dataUpdate.push(answerData);

								var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getAnswerList, 'keyId' : 'auditId'};
								indexedDB.createObjectStore(constant.getAnswerList, objectStoreNameApi);
								indexedDB.writeData(constant.getAnswerList, objectStoreNameApi);
							}
						}else{
							var dataUpdate = [{'auditId': auditId, 'answerList': AnswersJson}];

							var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getAnswerList, 'keyId' : 'auditId'};
							indexedDB.createObjectStore(constant.getAnswerList, objectStoreNameApi);
							indexedDB.writeData(constant.getAnswerList, objectStoreNameApi);
						}

						if (window.navigator.onLine) {
							if (AnswersJson.length == 0) {
								var auditAnswers = data.filter(item => item.auditId == auditId);
								if (auditAnswers.length == 0) {
									AnswersJson = '[]';
								} else {
									AnswersJson = auditAnswers[0].answerList;
								}
							}
							// call api here
							api.updateAnswer(auditId, AnswersJson, function getF360UpdateAnswer(err, data) {
								if (err) {
									log.error('error updating audit answers: ' + err);
								}
								callbackOrLog(callback, null, data);
							});
						} else {
							callbackOrLog(callback, null, []);
						}
					});
				},updateReviewResults: function updateReviewResults(auditId, draftNotesJson,nextEvalDate, callback) {
					indexedDB.readData(constant.getReviewResultsAndDraft, constant.getReviewResultsAndDraft, function getData(err, data){
						if (err) {
							console.error('error in reading getReviewResultsAndDraft data (updateReviewResults): ', err);
						}
						if (data && data.length) {
							var foundIndex = data.findIndex(item => item.auditId == auditId);
							if (draftNotesJson.length > 0) {
								var dataUpdate = _.clone(data);
								if (foundIndex > -1) {
									dataUpdate.splice(foundIndex, 1);
								}

								var reviewResultsAndDraftData = {'auditId': auditId, 'reviewResultsAndDraft': draftNotesJson};
								dataUpdate.push(reviewResultsAndDraftData);

								var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getReviewResultsAndDraft, 'keyId' : 'auditId'};
								indexedDB.createObjectStore(constant.getReviewResultsAndDraft, objectStoreNameApi);
								indexedDB.writeData(constant.getReviewResultsAndDraft, objectStoreNameApi);
							}
						}

						if (window.navigator.onLine) {
							if (draftNotesJson.length == 0) {
								var auditdraftNotes = data.filter(item => item.auditId == auditId);
								if (auditdraftNotes.length == 0) {
									draftNotesJson = '{}';
								} else {
									draftNotesJson = auditdraftNotes[0].reviewResultsAndDraft;
								}
							}
							// call api here
							api.updateReviewResults(auditId, draftNotesJson,nextEvalDate, function getF360ReviewResultsAndDraft(err, data) {
								if (err) {
									log.error('error getting overView list: ' + err);
								}
								callbackOrLog(callback, null, data);
							});
						} else {
							callbackOrLog(callback, null, []);
						}
					});
				},publishAudit: function publishAudit(auditId, draftNotesJson, callback) {
					indexedDB.readData(constant.getReviewResultsAndDraft, constant.getReviewResultsAndDraft, function getData(err, data){
						if (err) {
							console.log('err', err);
						}
						if (data && data.length) {
							var foundIndex = data.findIndex(item => item.auditId == auditId);
							if (draftNotesJson.length > 0) {
								var dataUpdate = _.clone(data);
								if (foundIndex > -1) {
									dataUpdate.splice(foundIndex, 1);
								}

								var reviewResultsAndDraftData = {'auditId': auditId, 'reviewResultsAndDraft': draftNotesJson};
								dataUpdate.push(reviewResultsAndDraftData);

								var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getReviewResultsAndDraft, 'keyId' : 'auditId'};
								indexedDB.createObjectStore(constant.getReviewResultsAndDraft, objectStoreNameApi);
								indexedDB.writeData(constant.getReviewResultsAndDraft, objectStoreNameApi);

								indexedDB.readData(constant.getList, constant.getList, function getListData(err, data){
									if (err) {
										console.error('error in reading getList data (publishAudit): ', err);
									}
									if (data && data.length) {
										 
										
										   var dataUpdate = _.clone(data);
		                                   var currentHerdId = _.get(MSF.getActiveHerd(),'herdId');
										   var foundIndex = data.findIndex(item => item.herdId == currentHerdId );
									
										   var herdData = {herdId: currentHerdId, auditList: []};	
											if (foundIndex > -1) {
												  _.set(herdData,'auditList',JSON.parse(_.get(dataUpdate[foundIndex],'auditList',"[]")));	
												 dataUpdate.splice(foundIndex, 1);
											}
											
											var audit = _.find(herdData.auditList,{AuditId: auditId});
											if(audit){
												  var draftNotesData = JSON.parse(draftNotesJson); 
												  var reportDate  = _.get(draftNotesData,'reviewDraftRptJson.reportDate',"");
												  var nextEvalDate = _.get(draftNotesData,'resultsWriteRptJson.nextEvaluationDate',"");
	                                             
												_.set(audit,'PublishedOn',reportDate);
												_.set(audit,'NextEvaluationDate',nextEvalDate);
											}
	
										
											_.set(herdData,'auditList',JSON.stringify(herdData.auditList));
				
											dataUpdate.push(herdData);
			
											var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getList, 'keyId' : 'herdId'};
											indexedDB.createObjectStore(constant.getList, objectStoreNameApi);
											indexedDB.writeData(constant.getList, objectStoreNameApi);
										
									}

									if (window.navigator.onLine) {
										if (draftNotesJson.length == 0) {
											var auditdraftNotes = data.filter(item => item.auditId == auditId);
											if (auditdraftNotes.length == 0) {
												draftNotesJson = '{}';
											} else {
												draftNotesJson = auditdraftNotes[0].reviewResultsAndDraft;
											}
										}
										// call api here
										api.publishAudit(auditId, draftNotesJson, function publishF360Audit(err, data) {
											if (err) {
												log.error('error getting overView list: ' + err);
											}
											callbackOrLog(callback, null, data);
										});
									} else {
										callbackOrLog(callback, null, []);
									}

									
								});
							
							}

                            


						}

					
					});
				},
				createNewAudit: function createNewAudit(auditApiVersion,herdId, personId, lact1, lact2, callback) {
			
						api.createNewAudit(auditApiVersion,herdId, personId, lact1, lact2, function createNewAudit(err, auditData) {
							if (err) {
								log.error('error create new audit:' + err);
							}
							if (auditData) {

								indexedDB.readData(constant.getList, constant.getList, function getListData(err, data){
									if (err) {
										console.log('err', err);
									}
									if (data && data.length) {
										 
										var newHerdListItem = {
											"ApiVersion": auditApiVersion,
											"HerdId":herdId,
											"AuditId":_.get(auditData,'AuditId',null),
											"PersonId":personId,
											"Name": cookies.user.FirstName + ' ' + cookies.user.LastName,
											"NextEvaluationDate":"",
											"DetailsJson":"",
											"SyncedOn":"",
											"SyncedDevice":null,
											"PublishedOn":null,
											"ModifiedOn":new Date().toString(),
											"CreatedOn":new Date().toString(),
											"Lact1_VWP":lact1,
											"Lact2_VWP":lact2,
											"Deleted":false,
											"Authors": JSON.stringify([{PersonId:personId,FirstName:cookies.user.FirstName,LastName: cookies.user.LastName}]),
											"CheckedOutTo": JSON.stringify({PersonId:personId,FirstName:cookies.user.FirstName,LastName: cookies.user.LastName,Email:cookies.user.Email})
										};
										
										   var dataUpdate = _.clone(data);
		
										   var foundIndex = data.findIndex(item => item.herdId == herdId);
									
										   var herdData = {herdId: herdId, auditList: []};	
											if (foundIndex > -1) {
												  _.set(herdData,'auditList',JSON.parse(_.get(dataUpdate[foundIndex],'auditList',"[]")));	
												 dataUpdate.splice(foundIndex, 1);
											}
											
											herdData.auditList.push(newHerdListItem);
											_.set(herdData,'auditList',JSON.stringify(herdData.auditList));
				
											dataUpdate.push(herdData);
			
											var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getList, 'keyId' : 'herdId'};
											indexedDB.createObjectStore(constant.getList, objectStoreNameApi);
											indexedDB.writeData(constant.getList, objectStoreNameApi);
										
									}
								});


								callbackOrLog(callback, null, auditData || null);
							}
						});
				
						
					
				},
				
				deleteAudit: function deleteAudit(auditId, callback) {
					if(window.navigator.onLine){
						indexedDB.readData(constant.getList, constant.getList, function getData(err, data){
							if (err) {
								console.log('err', err);
							}
							if (data && data.length) {
	
								var currentHerd = MSF.getActiveHerd();
	
								var foundIndex = data.findIndex(item => item.herdId == currentHerd.herdId);
								var dataUpdate = _.clone(data);
	
								
								var auditData = _.find(dataUpdate, {herdId: currentHerd.herdId});
	
								if (auditData) {
									var auditList = JSON.parse(auditData.auditList);
	                                 var activeAuditIndex = auditList.findIndex(audit => audit.AuditId === auditId);
									var activeAudit = _.find(auditList,{AuditId:auditId});
									if(activeAudit){
	
										if (foundIndex > -1) {
											dataUpdate.splice(foundIndex, 1);
										 
										}
										if(activeAuditIndex > -1){
											auditList.splice(activeAuditIndex,1);
										}
										
	
										var auditListData = {'herdId': currentHerd.herdId, 'auditList': JSON.stringify(auditList)};
										dataUpdate.push(auditListData);
	
										var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getList, 'keyId' : 'herdId'};
										indexedDB.createObjectStore(constant.getList, objectStoreNameApi);
										indexedDB.writeData(constant.getList, objectStoreNameApi);
	
								
											api.deleteAuditbyAuditId(auditId, function deleteAuditbyAuditId(err, data) {
												if (err) {
													log.error('error delete audit: ' + err);
												}
												if (data) {
													callbackOrLog(callback, null, data || null);
												}
											});
									
										callbackOrLog(callback, null, []);
										
	
									}else{
										callbackOrLog(callback, null, []);
									}
	
									
								}else{
									callbackOrLog(callback, null, []);
								} 
	
								
								
							}else{
								callbackOrLog(callback, null, []);
							}
						});
	

					}else{

					

					indexedDB.readData(constant.getList, constant.getList, function getData(err, data){
						if (err) {
							console.log('err', err);
						}
						if (data && data.length) {

							var currentHerd = MSF.getActiveHerd();

							var foundIndex = data.findIndex(item => item.herdId == currentHerd.herdId);
							var dataUpdate = _.clone(data);

							
							var auditData = _.find(dataUpdate, {herdId: currentHerd.herdId});

							if (auditData) {
								var auditList = JSON.parse(auditData.auditList);

								var activeAudit = _.find(auditList,{AuditId:auditId});
								if(activeAudit){

									if (foundIndex > -1) {
										dataUpdate.splice(foundIndex, 1);
									 
									}
									
									_.set(activeAudit,'Deleted',true);
									

									var auditListData = {'herdId': currentHerd.herdId, 'auditList': JSON.stringify(auditList)};
									dataUpdate.push(auditListData);

									var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getList, 'keyId' : 'herdId'};
								    indexedDB.createObjectStore(constant.getList, objectStoreNameApi);
									indexedDB.writeData(constant.getList, objectStoreNameApi);

								
									callbackOrLog(callback, null, []);
									

								}else{
									callbackOrLog(callback, null, []);
								}

								
							}else{
								callbackOrLog(callback, null, []);
							} 

							
							
						}else{
							callbackOrLog(callback, null, []);
						}
					});

				}
				
						
				},
				checkInOutAudit: function checkInOutAudit(checkInOutData, callback) {
					if(window.navigator.onLine){
						indexedDB.readData(constant.getList, constant.getList, function getData(err, data){
							if (err) {
								console.error('error in reading getList objectstore (checkInOutAudit): ', err);
							}
							if (data && data.length) {
								var auditHerdId = _.get(checkInOutData,'herdId',null);
								var auditId = _.get(checkInOutData,'auditId',null);
								
								var foundIndex = data.findIndex(item => item.herdId == auditHerdId);
								var dataUpdate = _.clone(data);

								var cachedAuditData = _.find(dataUpdate, {herdId: auditHerdId})
								if (cachedAuditData) {
									if(foundIndex > -1) {
										dataUpdate.splice(foundIndex, 1);
									}
								    var auditList = [];
									try {
										auditList = JSON.parse(_.get(cachedAuditData,"auditList"));
									} catch (error) {
										console.log("error in parsing audit list in AuditService.checkInOutAudit");
										
									}
									if(auditList.length > 0){
										var cachedAudit = _.find(auditList,{AuditId:auditId});
										var foundCachedIndex = auditList.findIndex(item => item.AuditId == auditId);
										if(cachedAudit){
											if(foundCachedIndex > -1){
												auditList.splice(foundCachedIndex, 1);
											}
											_.set(cachedAudit,'CheckedOutTo',_.get(checkInOutData,'checkedOutTo',null));
											_.set(cachedAudit,'Authors',_.get(checkInOutData,'authors',null));
											auditList.push(cachedAudit);
											
											var auditListData = {'herdId': auditHerdId, 'auditList': JSON.stringify(auditList)};
											dataUpdate.push(auditListData);
	
											var objectStoreNameApi = {'data': dataUpdate, 'tableName' : constant.getList, 'keyId' : 'herdId'};
											indexedDB.createObjectStore(constant.getList, objectStoreNameApi);
											indexedDB.writeData(constant.getList, objectStoreNameApi);
										}

										
									}

								}else{
									log.error("audit could not be found in this current herd's audit list");
								}


								
							}else{
								log.error("no data returned from getList objectstore");
							}

							api.checkInOutAudit(checkInOutData, function checkInOutAudit(err, data) {
								if (err) {
									log.error('error check in/out audit: ' + err);
									callbackOrLog(callback, err, null);
									
								}else{
									callbackOrLog(callback, null, null);
								}
								
								
								
							});

						});
					}
				}
			};
			return service;
		}
	]);
})();
